import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable, Subject, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, debounce } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { Router, Data, ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { SWAlertService } from '../../services/swalert.service';
import { BusinessDayService } from '../../services/business-day.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/public_api';
import { promise } from 'protractor';
import { isNullOrUndefined } from 'util';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import Swal from 'sweetalert2';
import { async } from 'rxjs/internal/scheduler/async';
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension: any, Accept: any
declare var ArrFile: any[];
@Component({
  selector: 'app-other',
  templateUrl: './other.component.html',
  styleUrls: ['./other.component.css'],
  providers: [DatePipe, TSFuntionService, DecimalPipe]
})
export class OtherComponent implements OnInit {
  VendorCodemaxLength: any = 40;
  isUseIo: boolean = false;
  isUseGL: boolean = false;
  EditInvoiceCode: any;
  EditInvoiceDate: any;
  ResultPermission: boolean;
  //NoResults
  TypeNoResult: any;
  CopyNoResult: any;
  GlNoResult: any[] = [];
  CostCenterNoResult: any[] = [];
  IONoResult: any[] = [];
  BankNoResult: any;
  BankNoResult2: any;
  Approve1NoResult: any;
  Approve2NoResult: any;
  isCountryNoResult: any = false;
  sAmphorNoResult: any = false;
  sTumbonNoResult: any = false;
  sSubDistrictNoResult: any = false;
  //
  clicked: boolean  = false;
  isReject: boolean = false;
  nReqUrgentDay: any;
  olddate: any = "";
  IsNotFill_IO = false;
  IsNotFill_GL = false;
  isDraft: boolean = false;
  isNew: boolean = true;
  isSubmit: boolean = false;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  sReqID: any;
  sReqCode: any;
  haveRequestCode: boolean = false;
  haveComments: boolean = true;
  sComment: string = "";
  sCommentSSC: string = "";
  IsReqUrgent: boolean = false;
  IsLoadingBankAll: boolean = false;
  nEditindex: any;
  isEdit: boolean;
  isPrint: boolean = false;
  isEditFromhome: boolean = false;
  isThai: boolean;
  bg_color: string = '';
  IsVendorOneTime: boolean = false;
  myFiles: string[] = [];
  sMsg: string = '';
  name: string;
  vendorcode: string;
  sGL: string;
  message: string;
  messagebank: string = " ";
  messageAsset: string = "";
  hBranch: boolean;
  hBank: boolean;
  hVatAmount: boolean;
  hidbankother: boolean;
  isShowPO: boolean;
  nComcode: any;
  nCostCenterCode: any;
  sCostcen: any;
  ArrInvoiceOther: Array<any> = [];
  ArrTransactionHistory: Array<any> = [];
  ArrInvoicelength: any;
  ArrMaster: Array<any> = [];
  DataEmployee: any;
  DataRequest: any;
  DataVendor: any = [];
  DataVendorAll: any = [];
  DataGL: any;
  DataCostCenter: any;
  DataIO: any;
  DataApprover: any;
  DataBusinessArea: any;
  ArrEmployee: any[] = [];
  ArrRequest: any[] = [];
  ArrVendor: any[] = [];
  ArrVendorName: any[] = [];
  _ArrCountry: any;
  _ArrProvince: any;
  _ArrAmphur: any;
  _ArrTumbon: any;
  ArrIO: any[] = [];
  sArrGL: any[] = [];
  ArrCostCenter: any[] = [];
  ArrApprover: any[] = [];
  GetApprover: any;
  DataBankBranch: any;
  masterDataBankBranch: any;
  DataBankBranch2: any;
  masterDataBankBranch2: any;
  DataBankAccountNo: any;
  Currency: any;
  Currencys: any;
  WHT: any;
  VatType: any;
  Bank: any;
  TM_Config: any;
  today: number = Date.now();
  dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy')
  maxDate: Date;
  maxDateinvoice: any;
  TODAY: Date;
  toDay: Date;
  Settodate: Date;
  todayy: any;
  holidays: Date[]; //ตัวแปรรับค่า holiday
  _HolidayDB = [];
  urgentDay: number = 6;
  bsConfig: Partial<BsDatepickerConfig>; //Set congic datepicker เท่านั้น ส่วน daterangpicker จะใช้อีก confic หนึ่ง
  paytoOtherForm: FormGroup;
  get _paytoOtherForm() { return this.paytoOtherForm.controls; }
  get ArrGL() { return this._paytoOtherForm.ArrGL as FormArray; }//Dynamic
  fileType: any;
  limit: any;
  FieldOnetimeValid: any[] = [
    { _Field: "sCountryID", _Validator: Validators.required, _Value: "213" },
    { _Field: "txtCountryID", _Validator: Validators.required, _Value: "ประเทศไทย" },
    { _Field: "sProvCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sProvName", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpName", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonName", _Validator: Validators.required, _Value: "" },
    { _Field: "sPostCode", _Validator: null, _Value: "" },
    { _Field: "sPhoneNumber", _Validator: null, _Value: "" },
    { _Field: "sFaxNumber", _Validator: null, _Value: "" },
    { _Field: "sVendorEmail", _Validator: Validators.email, _Value: "" },
  ];
  constructor(private http: HttpClient, private formBuilder: FormBuilder, public datepipe: DatePipe, private SW: SWAlertService, private BusinessDay: BusinessDayService, private _decimalPipe: DecimalPipe, private System: TSFuntionService, private activatedRoute: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    this.System.BlockUI();
    this._ArrAmphur = [];
    this._ArrTumbon = [];
    let ua = this.System.GetUserStorage();
    this.nComcode = ua.sCompCode;
    this.ArrMaster[0] = [];
    this.isEdit = false;
    this.maxDate = new Date();
    this.maxDateinvoice = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1)
    this.TODAY = new Date();
    this.toDay = new Date();
    this.hBranch = true;
    this.hBank = false;
    this.SetForm();
    await this.http.get<any>("api/Autocomplete/TM_Holiday/*").toPromise().then(res => {
      if (res) {
        this._HolidayDB = res.filter(f => f.IsDelete == false && f.cActive == "Y");
      }
      this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate))
    })
    //confic datepicker
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue' //set theme
      , dateInputFormat: 'DD/MM/YYYY' //set Format
      , showWeekNumbers: false
      , datesDisabled: this.holidays //set holidays (type Date only)
      , daysDisabled: [0, 6]
    });

    this.today = this.BusinessDay.SetToday(this.holidays).getTime();
    this.dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy');
    // this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.TODAY = this.BusinessDay.SetToday(this.holidays);
    this.TODAY.setDate(this.TODAY.getDate() + 1);
    this.TODAY = this.BusinessDay.SetNextDate(this.TODAY, this.holidays);
    this.paytoOtherForm.patchValue({ dDueDate: this.TODAY })

    await this.GetAutocomplete();
    this.hVatAmount = false;
    this.paytoOtherForm.controls['sBranch'].disable();
    this.paytoOtherForm.controls['nWHTOther'].disable();
    this.paytoOtherForm.controls['nWHTOther2'].disable();
    this.paytoOtherForm.controls['BankOther'].disable();
    this.paytoOtherForm.controls['sVendorName'].disable();
    this.paytoOtherForm.controls['sTAXID'].disable();
    this.paytoOtherForm.controls['sAddress'].disable();
    this.paytoOtherForm.controls['ddBankKey2'].disable();
    this.checkUseIo();
    this.checkUseGL();
    // let Duedate = this.paytoOtherForm.value.dDueDate; //get value dDue formControlName
    let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
    this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
    this.IsReqUrgent = check_date < this.urgentDay ? true : false;
    this.nReqUrgentDay = check_date;
    this.paytoOtherForm.patchValue({ dDueDate: this.TODAY });
    this.activatedRoute.queryParams.subscribe(async params => {
      let ID: string = this.System.GetQuerySTR('str');
      let ID2: string = this.System.GetQuerySTR('ros');
      this.sReqID = await this.System.Decrypt(ID);
      if (ID2 !== 'undefined') {
        this.sReqID = await this.System.Decrypt(ID2);
        this.isForROS = true;
        this.urgentDay = 8;
      }
      if(this.sReqID === ''){
        this.isNewRequest = true;
      }
      this.Edit(this.sReqID);
    });
    this.hidbankother = ua.sCompCode != 396;
    await this.getFileType();
    await this.getFileLimit();
    var setUp = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit
    };
    Uploadfiles(setUp);
    Clearuploadfile();
  }
  async Reject() {
    let _this = this;
    let sComment = _this.paytoOtherForm.get('sComment').value;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytoOtherForm.get('sRequestID').value,
          sComment: sComment,
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      _this.SW.SwAlert.Confirm(_this.SW.BoxMsg.Title_Confirm, _this.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid #dde4f6';
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limit = result;
    });
  }
  setVat() {
    let _thisOther = this;
    let vatType = this.paytoOtherForm.value.ddVatType;
    if (vatType != "-1") {
      let datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
      this.hVatAmount = datavat.TAX_CODE == "VZ" ? true : false;

      this.paytoOtherForm.patchValue({ nVat: datavat.nVAT });
      if (this.hVatAmount == true) {
        _thisOther.paytoOtherForm.controls.nVatAmount.clearValidators();
        _thisOther.paytoOtherForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _thisOther.paytoOtherForm.controls.nVatAmount.setValidators([]);
        _thisOther.paytoOtherForm.controls.nVatAmount.setErrors(null);
        _thisOther.paytoOtherForm.controls.nVatAmount.updateValueAndValidity();
        _thisOther.paytoOtherForm.controls.nVatAmount.disable();
        _thisOther.calVat();
        _thisOther.paytoOtherForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _thisOther.paytoOtherForm.controls["nVatAmount"].clearValidators();
        _thisOther.paytoOtherForm.controls["nVatAmount"].setValidators([Validators.required]);
        _thisOther.paytoOtherForm.controls["nVatAmount"].updateValueAndValidity();
        _thisOther.paytoOtherForm.controls.nVatAmount.enable();
        _thisOther.calVat();
      }
    }
  }
  Editsetvat() {
    let _thisOther = this;
    let vatType = this.paytoOtherForm.value.ddVatType;
    if (vatType != "-1") {
      let datavat = { nVAT: '', TAX_CODE: '' };
      if (this.VatType.filter(s => s.TAX_CODE == vatType).length > 0) {
        datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
        this.paytoOtherForm.patchValue({ nVat: datavat.nVAT });
        this.hVatAmount = datavat.TAX_CODE == "VZ" ? true : false;
      }
      this.paytoOtherForm.patchValue({ nVat: datavat.nVAT });
      if (this.hVatAmount == true) {
        _thisOther.paytoOtherForm.controls.nVatAmount.clearValidators();
        _thisOther.paytoOtherForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _thisOther.paytoOtherForm.controls.nVatAmount.setValidators([]);
        _thisOther.paytoOtherForm.controls.nVatAmount.setErrors(null);
        _thisOther.paytoOtherForm.controls.nVatAmount.updateValueAndValidity();
        _thisOther.paytoOtherForm.controls.nVatAmount.disable();
        //_thisOther.calVat();
        _thisOther.paytoOtherForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _thisOther.paytoOtherForm.controls["nVatAmount"].clearValidators();
        _thisOther.paytoOtherForm.controls["nVatAmount"].setValidators([Validators.required]);
        _thisOther.paytoOtherForm.controls["nVatAmount"].updateValueAndValidity();
        _thisOther.paytoOtherForm.controls.nVatAmount.enable();
      }
    }
  }
  handler(select): void {
    if (select == 1) {
      let Duedate = this.paytoOtherForm.value.dDueDate; //get value dDue formControlName
      let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, Duedate, this.holidays);
      this.message = (check_date < this.urgentDay && this.isSubmit != true && check_date > 0) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
      this.nReqUrgentDay = check_date;
      this.IsReqUrgent = check_date < this.urgentDay ? true : false;
      this.paytoOtherForm.patchValue({ dDueDate: Duedate });
    }
    if (select == 2) {
      let Invoicedate = this.paytoOtherForm.value.dInvoiceDate;
      this.paytoOtherForm.patchValue({ dInvoiceDate: Invoicedate });
    }
  }
  //#region "GetAutocomplete"
  async GetAutocomplete() {
    this.http.get(this.System.SiteName + "api/Autocomplete/TUserpermission/*/sCompCode/" + this.nComcode + "/nRole/5").subscribe((data: Response) => {
      this.DataEmployee = data;
      this.ArrEmployee = this.DataEmployee.map(data => data.sName + " " + data.sSurName)
    })

    //AutocompleteMT_Vendor
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      params: new HttpParams()
        .set("sComCode", this.nComcode + "")
        .set("sReqType", '50'),

    };
    let _thisOther = this;
    this.http.get<any>(this.System.SiteName + "api/_System/GetVDNoReqType", httpOptions).toPromise().then(data => {
      this.DataVendorAll = data;
      data.filter(function (item) {
        if ((item.IsOnetimeVendor == false)) {
          if (!item.VENDOR_CODE.includes('PC')) {
            _thisOther.DataVendor.push(item);
          }
        }
      });
      this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.VENDORNAME, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.ADDRESS, sVendorName: re.VENDORNAME, TAX_NUMBER1: re.TAX_ID, IsOnetimeVendor: re.IsOnetimeVendor, sValue: re.sValue }))
    })

    /* this.http.get(this.System.SiteName + "api/Autocomplete/VD/50/" + this.nComcode + "").subscribe((data: Response) => {
       this.DataVendor = data;
       this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + ": " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3 }))
       this.paytoOtherForm.patchValue({});
     })*/

    //AutocompleteTRequest
    this.ArrRequest = [];
    this.http.get(this.System.SiteName + "api/_Paytovendor/GetCopyOther/" + this.nComcode + "").subscribe((data: Response) => {
      this.DataRequest = data;
      if (this.DataRequest != null) {
        this.ArrRequest = this.DataRequest.map(re => re.sRequestCode)
      }
    })

    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteGL
    await this.http.get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise().then((data: Response) => {
      this.DataGL = data;
      this.sArrGL = this.DataGL;
    })

    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteCOSTCENTER
    this.http.get(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).subscribe((data: Response) => {
      this.DataCostCenter = data;
      this.ArrCostCenter = this.DataCostCenter;
    })

    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteIO
    await this.http.get(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then((data: Response) => {
      this.DataIO = data;
      if (this.DataIO != null) {
        this.ArrIO = this.DataIO;
        this.ArrMaster[0] = this.ArrIO;
      }
    })

    //AutocompleteBankBranch
    this.DataBankBranch = [];

    //AutocompleteBankAccount
    this.DataBankBranch2 = [];
    this.masterDataBankBranch2 = [];
    //await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/1/1/1/1/PARTNER_BANK/ASC").subscribe((data: any) => {
    //  this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
    //  this.masterDataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
    //})

    //AutocompleteApprover
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetApproverAll/" + this.nComcode + "").toPromise().then((data: Response) => {
      if (data) {
        this.DataApprover = data;
      } else {
        this.DataApprover = [];
      }

      this.ArrApprover[0] = [];
      this.ArrApprover[1] = [];

      //GetApprover
      this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/50").toPromise().then((data: Response) => {
        if (data) {
          this.GetApprover = data[0];
        } else {
          this.GetApprover = null;
        }
        if (this.GetApprover != null) {
          if (this.GetApprover.cActive == "Y") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
            if (this.GetApprover.IsApprover_1 == false) {
              this.paytoOtherForm.controls['ddApprover1'].disable();
              this.paytoOtherForm.controls['cSkipApprove1'].setValue(true);
            } else {
              this.paytoOtherForm.controls['ddApprover1'].enable();
              this.paytoOtherForm.controls['cSkipApprove1'].setValue(false);
              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              this.paytoOtherForm.patchValue({
                ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
                sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
              })
            }
            if (this.GetApprover.IsApprover_2 == false) {
              this.paytoOtherForm.controls['ddApprover2'].enable();
            } else {
              this.paytoOtherForm.controls['ddApprover2'].enable();

              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              this.paytoOtherForm.patchValue({
                ddApprover2: isNullOrUndefined(name1) == true ? "" : name1.name1,
                sApprove2: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
              })
            }
          } else if (this.GetApprover.cActive == "N") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
          }
        }
      })

    })
    //Country
    await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise().then(res => {
      if (res) {
        this._ArrCountry = res;
      }
    });
    //ProvCode
    await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
      if (res) {
        this._ArrProvince = res;
      }
    });

    //DropdownCurrency
    this.http.get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*").subscribe((data: Response) => {
      this.Currency = data;
    })

    //DropdownGetWHT
    this.http.get(this.System.SiteName + "api/_Paytovendor/GetWHT").subscribe((data: Response) => {
      this.WHT = data;
    })

    //DropdownVatType
    this.http.get(this.System.SiteName + "api/Autocomplete/Like/MT_VATTYPE/*/sReqType/50").subscribe((data: Response) => {
      let tempData: any;
      tempData = data
      //this.VatType = tempData.filter(f => f.TAX_CODE != "D7");
      this.VatType = tempData;
    })
    //DropdownBank
    this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANK/*/Company/" + this.nComcode + "/Transfer/Y").subscribe((data: Response) => {
      this.Bank = data;
      if (this.Bank.length == 1) {
        this.paytoOtherForm.patchValue({
          ddBank: this.Bank[0].BankName
        })
      }
    })

    //DropdownBusinessAreas
    this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*").subscribe(data => {
      if (data != null) {
        this.DataBusinessArea = data;
        this.paytoOtherForm.patchValue({
          sBusinessArea: this.DataBusinessArea.filter(f => f.CompCode == this.nComcode)[0].BUSINESS_AREA,
        })

      }

    })

    //getInvoiceLast
    /*  this.http.get(location.origin + "/api/Autocomplete/MT_BANK*//*").subscribe((data: Response) => {
        this.Bank = data;
      })*/

  }
  //#endregion
  onUserSelect(sName) {
    let lstData = this.DataEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData != undefined) {
      this.nComcode = lstData.sCompCode;
      this.paytoOtherForm.patchValue({
        nContactID: lstData.sEmpCode,
        sName: lstData.sName + " " + lstData.sSurName,
        sEmail: lstData.sEmail,
        sUnit: lstData.sUnit,
        sTel: lstData.sTel,
      });

    } else {

    }
  }
  async onTypeSelect(type, isOnetime) {
    let _thisOther = this;
    let Type = this.paytoOtherForm.value.ntype;
    if (type != null) {
      let stype = type.substring(0, 2);
      if (stype == "PX") {
        Type = 11;
      } else if (stype == "PF") {
        Type = 10;
      }
    }
    let Fields = ["sVendorName", "sTAXID", "sAddress"];
    /*   //AutocompleteMT_Vendor
       this.http.get(this.System.SiteName + "api/Autocomplete/VD/" + Type + "/" + this.nComcode + "").subscribe((data: Response) => {
         this.DataVendor = data;
         if (this.DataVendor == null) {
           this.ArrVendor = [];
         } else {
           this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3 }))
         }
       })
       this.paytoOtherForm.patchValue({
         nVendorCode: "",
         sTAXID: "",
         sVendorName: "",
         cbOffice: 1,
         sBranch: "",
         sAddress: "",
       })*/

    if (Type == 11 || isOnetime == true) {
      // IsVendorOneTime
      this.IsVendorOneTime = true;
      this.ArrVendorName = this.DataVendorAll.filter(f => f.IsOnetimeVendor == true && f.VENDOR_CODE.includes('PX')).map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.VENDORNAME, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.ADDRESS, sVendorName: re.VENDORNAME, TAX_NUMBER1: re.TAX_ID, IsOnetimeVendor: re.IsOnetimeVendor }));
      this.isThai = true;
      Fields.forEach(function (field) {
        _thisOther.paytoOtherForm.controls[field].enable();
        _thisOther.paytoOtherForm.controls[field].markAsUntouched({ onlySelf: true })
        _thisOther.paytoOtherForm.controls[field].setValidators(Validators.required)
        _thisOther.paytoOtherForm.controls[field].setErrors(null);
        _thisOther.paytoOtherForm.controls[field].updateValueAndValidity();


      })

      this.FieldOnetimeValid.forEach(function (Item) {
        _thisOther.paytoOtherForm.get(Item._Field).markAsUntouched({ onlySelf: true });
        _thisOther.paytoOtherForm.controls[Item._Field].setValue(Item._Value);
        _thisOther.paytoOtherForm.controls[Item._Field].setValidators(Item._Validator);
        _thisOther.paytoOtherForm.controls[Item._Field].setErrors(null);
        _thisOther.paytoOtherForm.controls[Item._Field].updateValueAndValidity();
      });
      this.paytoOtherForm.patchValue({
        sTAXID: "",
        sVendorName: "",
        sAddress: "",
        sPhoneNumber: "",
        sAmpCode: "",
        sAmpName: "",
        sBranch: "",
        sComcode: "",
        sCountryID: "213",
        txtCountryID: "ประเทศไทย (Thailand)",
        sVendorEmail: "",
        sFaxNumber: "",
        sPostCode: "",
        sProvCode: "",
        sProvName: "",
        sTumbonCode: "",
        sTumbonName: "",
        ddBankKey: "",
        nBankKey: "",
        ddBankKey2: "",
        nBankKey2: "",
      });
      this.DataBankBranch2 = [];
      this.IsLoadingBankAll = true;
      await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/1/All").toPromise().then(res => {
        if (res) {
          this.DataBankBranch = res;
          this.IsLoadingBankAll = false;
        }
      })
    }
    if (Type != 11 && isOnetime != true) {
      this.IsVendorOneTime = false;
      this.ArrVendorName = [];
      Fields.forEach(function (field) {
        _thisOther.paytoOtherForm.controls[field].disable();
        _thisOther.paytoOtherForm.controls[field].markAsUntouched({ onlySelf: true })
        _thisOther.paytoOtherForm.controls[field].setValidators(null)
        _thisOther.paytoOtherForm.controls[field].setValue(" ");
        _thisOther.paytoOtherForm.controls[field].setErrors(null);
        _thisOther.paytoOtherForm.controls[field].updateValueAndValidity();

      })

      this.FieldOnetimeValid.forEach(function (Item) {
        _thisOther.paytoOtherForm.controls[Item._Field].setValue("");
        _thisOther.paytoOtherForm.controls[Item._Field].setErrors(null);
        _thisOther.paytoOtherForm.controls[Item._Field].clearValidators();
      });
    }
    //GetApprover
    // this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/" + "50" + "").subscribe((data: Response) => {
    //   let dataraw: any;
    //   let Data: any;
    //   if (data) {
    //     Data = data[0];
    //   } else {
    //     Data = null;
    //   }

    //   if (Data != null) {
    //     if (Data.cActive == "Y") {
    //       if (Data.IsApprover_1 == false) {
    //         this.paytoOtherForm.controls['ddApprover1'].disable();
    //         this.paytoOtherForm.controls['cSkipApprove1'].setValue(true);
    //       } else {
    //         this.paytoOtherForm.controls['ddApprover1'].enable();
    //         let nUserID = this.DataApprover.filter(f => f.nUserID == Data.name1ID)[0]
    //         this.paytoOtherForm.patchValue({
    //           ddApprover1: Data.name1,
    //           sApprove1: nUserID.nUserID
    //         })
    //       }
    //       if (Data.IsApprover_2 == false) {
    //         this.paytoOtherForm.controls['ddApprover2'].enable();
    //       } else {
    //         this.paytoOtherForm.controls['ddApprover2'].enable();
    //         let nUserID = this.DataApprover.filter(f => f.nUserID == Data.name2ID)[0]
    //         this.paytoOtherForm.patchValue({
    //           ddApprover2: Data.name2,
    //           sApprove2: nUserID.nUserID
    //         })
    //       }
    //     } else if (this.GetApprover.cActive == "N") {
    //       this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
    //       this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
    //     }
    //   }

    // })
    ////AutocompleteApprover
    //this.http.get(location.origin + "/api/Autocomplete/TUserPermission/*/sCompCode/" + this.nComcode + "/nRole/2").subscribe((data: Response) => {
    //  this.DataApprover = data;
    //  this.ArrApprover = this.DataApprover.map(re => re.sName)
    //})
  }
  async onCopyRequestCodeSelect(RequestCode) {
    if (RequestCode != "") {
      let Data: any;
      let lstData = this.DataRequest.filter(user => user.sRequestCode == RequestCode)[0]
    
      await this.http.get(this.System.SiteName + "api/_paytovendor/GetRequest/" + lstData.sRequestID + "").toPromise().then((data: any) => {
        this.ClearInvoice();
        Data = data.filter(f => f.cActive != 'N');
      })
      if (Data != null) {
        this.ArrInvoiceOther = Data;
        this.Checkinvoice();
        this.CalGrand();
      }

      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", Data[0].sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", Data[0].sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let ddBankKey: any = null;
      let ddBankKey2: any = null;
      let checkBank: any = [];
      if (!_IsNullOrEmpty(Data[0].sBankKey)) {
        let Type = 50;
        let stype = Data[0].sVendorCode.substring(0, 2);
        if (stype == "PX") {
          Type = 11;
        }
        if (Type === 50) {
          await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + Data[0].sVendorCode).toPromise().then(res => {
            if (res) {
              this.DataBankBranch = res;
            }
            else {
              this.DataBankBranch = [];
            }
          })
          if (Data[0].sValue == "Y") {
            this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
          }
          if (this.DataBankBranch.length > 0) {

            if (Data[0].sValue == "Y" && Data[0].sBankKey === "N/A") {
              this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
            }
            else {
              await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + Data[0].sCompCode + "/BANK/" + Data[0].sBankKey + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
                if (data) {
                  this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
                }
              })
            }

          }
        }
        else {
          this.IsLoadingBankAll = true;
          await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/1/All").toPromise().then(res => {
            if (res) {
              this.DataBankBranch = res;
              this.IsLoadingBankAll = false;
            }
          })
        }
        checkBank = this.DataBankBranch.filter(x => x.BANK_KEY == Data[0].sBankKey);
        if (checkBank.length > 0) {
          ddBankKey = checkBank[0].NAME_OF_BANK;
        }
        ddBankKey2 = Data[0].sAccountNo;
      }
      this.paytoOtherForm.patchValue({
        nCopyRequest: Data[0].sRequestID,
        nVendorCode: Data[0].sVendorCode,
        sTAXID: Data[0].sTAXID,
        sVendorName: Data[0].sVendorName,
        cbOffice: Data[0].nOfficeType,
        sBranch: Data[0].sVendorBranch,
        sAddress: Data[0].sVendorAddress,
        sCountryID: Data[0].sCountryID,
        sProvCode: Data[0].sProvCode,
        sProvName: Data[0].sProvName,
        sAmpCode: Data[0].sAmpCode,
        sAmpName: Data[0].sAmpName,
        sTumbonCode: Data[0].sTumbonCode,
        sTumbonName: Data[0].sTumbonName,
        sPostCode: Data[0].sPostCode,
        sPhoneNumber: Data[0].sPhoneNumber,
        sFaxNumber: Data[0].sFaxNumber,
        sVendorEmail: Data[0].sVendorEmail,
        sAddressOneTime: Data[0].sAddressOneTime,
        sBankAccountName: Data[0].sPaymentType == "C" ? "" : Data[0].sAccountName,
        cbChequeType: Data[0].sPaymentType,
        ddBank: Data[0].sPaymentType == "C" ? "" : Data[0].sBankName,
        nBankAccountNo: Data[0].sAccountNo,
        ddBankKey: ddBankKey,
        ddBankKey2: ddBankKey2,
        nBankKey: ddBankKey != null ? Data[0].sBankKey : null,
        nBankKey2: Data[0].sBankKey2,
        BankOther: Data[0].sBankOther,
        ddApprover1: Data[0].sUserApprove1,
        ddApprover2: Data[0].sUserApprove2,
        sApprove1: Data[0].nApprove1 == null ? null : Data[0].nApprove1,
        sApprove2: Data[0].nApprove2 == null ? null : Data[0].nApprove2,
        cSkipApprove1: Data[0].cSkipApprove1 == "Y" ? true : false,
        IsPOinvoice: Data[0].IsPOinvoice,
        sPONo: Data[0].sPONo,
        sPOitem: Data[0].sPOitem,
        sMatDoc: Data[0].sMatDoc,
        sPORemark: Data[0].sPORemark,
        sComment: Data[0].sComment,
        sCommentSSC: Data[0].sCommentSSC,
      });
      this.sComment = Data[0].sComment;
      this.sCommentSSC = Data[0].sCommentSSC;
      if (Data[0].cSkipApprove1 == "Y") {
        this.paytoOtherForm.get('ddApprover1').disable()
      } else {
        this.paytoOtherForm.get('ddApprover1').enable();
      }
      this.hBranch = Data[0].nOfficeType == 2 ? false : true;
      if (this.hBranch == false) {
        this.paytoOtherForm.controls['sBranch'].enable();
        this.paytoOtherForm.patchValue({
          sBranch: Data[0].sVendorBranch,
          cbOffice: Data[0].nOfficeType,
        })
      }


      this.isShowPO = this.paytoOtherForm.get('IsPOinvoice').value;

      if (this.isShowPO) {
        this.paytoOtherForm.controls.sPONo.setValidators([Validators.required]);

        this.paytoOtherForm.controls.sPOitem.setValidators([Validators.required]);

        this.paytoOtherForm.controls.sMatDoc.setValidators([Validators.required]);
      }
      this.hidBankDetail();
    }
  }
  unique = (value, index, self) => {
    return self.indexOf(value) === index
  }
  forPX = () => {
    var vendor = this.paytoOtherForm.value.nVendorCode + "XX";
    vendor = vendor.substring(0, 2);
    var isNotPX = vendor === "PX";
    return isNotPX;
  }
  async onVendorSelect(event) {
    let _thisOther = this;
    let taxID = "";

    await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + event.item.VENDOR_CODE).toPromise().then(res => {
      if (res) {
        this.DataBankBranch = res;
      }
      else {
        this.DataBankBranch = [];
      }
    })
    if (event.item.sValue == "Y") {
      this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
    }
    if (this.DataBankBranch.length > 0) {
      this.paytoOtherForm.patchValue({
        ddBankKey: this.DataBankBranch[0].NAME_OF_BANK,
        nBankKey: this.DataBankBranch[0].BANK_KEY,
      })

      if (event.item.sValue == "Y" && this.DataBankBranch[0].BANK_KEY === "N/A") {
        this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
      }
      else {
        await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + event.item.VENDOR_CODE + "/BANK/" + this.DataBankBranch[0].BANK_KEY + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
          this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
        })
      }
      if (this.DataBankBranch2.length > 0) {
        this.paytoOtherForm.patchValue({
          ddBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
          nBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
        })
      }
      this.paytoOtherForm.controls['ddBankKey'].enable();
      this.paytoOtherForm.controls['ddBankKey2'].enable();
    }
    else {
      this.paytoOtherForm.patchValue({
        ddBankKey: null,
        nBankKey: null,
        ddBankKey2: null,
        nBankKey2: null,
      })
      this.paytoOtherForm.controls['ddBankKey'].enable();
      this.paytoOtherForm.controls['ddBankKey2'].disable();
    }

    if (event.item.VENDOR_CODE != undefined && event.item.VENDOR_CODE != "") {
      this.onTypeSelect(event.item.VENDOR_CODE, event.item.IsOnetimeVendor);
      let lstData = this.DataVendor.filter(s => s.VENDOR_CODE == event.item.VENDOR_CODE)[0];
      if (lstData != "") {
        this._ArrTumbon = [];
        const httpOptions_Amphur = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sProvCode", lstData.sProvCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
          if (res) {
            this._ArrAmphur = res;
          }
        });
        const httpOptions_Tumbon = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sAmpCode", lstData.sAmpCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
          if (res) {
            this._ArrTumbon = res;
          }
        });

        let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
        let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
        let value = { sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID };
        let events = { item: value };
        await this.OnCountryselect(events);
        let Type: any;
        let type = event.item.VENDOR_CODE != undefined && event.item.VENDOR_CODE != "" ? event.item.VENDOR_CODE : null;
        if (type != null) {
          let stype = type.substring(0, 2);
          if (stype == "PX") {
            Type = 11;
          } else if (stype == "PF") {
            Type = 10;
          }
        }
        let tax = "";
        let BankAccountName = "";
        if (_thisOther.IsVendorOneTime == true) {
          tax = lstData.TAX_ID == null ? "" : lstData.TAX_ID
          BankAccountName = "";
        }
        if (_thisOther.IsVendorOneTime == false && Type != 11) {
          tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID
          BankAccountName = isNullOrUndefined(lstData.VENDORNAME) == true ? "" : lstData.VENDORNAME;
        }
        if (Type != 11) {
          this.paytoOtherForm.patchValue({
            nVendorCode: lstData.VENDOR_CODE,
            sTAXID: tax,
            sVendorName: _thisOther.IsVendorOneTime == true ? "" : lstData.VENDORNAME,
            sAddress: _thisOther.IsVendorOneTime == true || lstData.ADDRESS == null ? "" : lstData.ADDRESS,
            sBankAccountName: BankAccountName, //lstData.VENDORNAME,
            sPhoneNumber: _thisOther.IsVendorOneTime == true ? "" : lstData.TEL,
            cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
            sAmpCode: _thisOther.IsVendorOneTime == true || lstData.sAmpCode == null ? "" : lstData.sAmpCode,
            sAmpName: _thisOther.IsVendorOneTime == true || isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
            sBranch: lstData.sBranch,
            sComcode: lstData.sComcode,
            sCountryID: _thisOther.IsVendorOneTime == true || isNullOrUndefined(lstData.sCountryID) == true ? "213" : lstData.sCountryID,
            txtCountryID: _thisOther.IsVendorOneTime == true || isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
            sVendorEmail: _thisOther.IsVendorOneTime == true ? "" : lstData.sEMAIL,
            sFaxNumber: _thisOther.IsVendorOneTime == true ? "" : lstData.sFaxNumber,
            sPostCode: _thisOther.IsVendorOneTime == true ? "" : lstData.sPostCode,
            sProvCode: _thisOther.IsVendorOneTime == true ? "" : lstData.sProvCode == null ? "" : lstData.sProvCode,
            sProvName: _thisOther.IsVendorOneTime == true || isNullOrUndefined(prov) == true ? "" : prov.sProvname,
            sTumbonCode: _thisOther.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
            sTumbonName: _thisOther.IsVendorOneTime == true || isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName
          });

          if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
            this.paytoOtherForm.controls['sBranch'].disable();
          }
        } else {
          this.paytoOtherForm.patchValue({
            nVendorCode: lstData.VENDOR_CODE,
            sBankAccountName: ""
          });
        }
        if (isNullOrUndefined(lstData.sCountryID) == true) {
          this.isThai = true;
          this.paytoOtherForm.patchValue({
            txtCountryID: "ประเทศไทย (Thailand)",
            sCountryID: "213",
            sProvCode: "",
            sAmpCode: "",
            sTumbonCode: "",
            sPostCode: "",
            sPhoneNumber: "",
            sFaxNumber: "",
            sVendorEmail: "",
            sAddressOneTime: "",
          })
          //ProvCode
          await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
            if (res) {
              this._ArrProvince = res;
            }
          });
        }
      } else {
        this.paytoOtherForm.patchValue({
          nVendorCode: null,
          sTAXID: null,
          sVendorName: null,
          cbOffice: 1,
          sBranch: null,
          sAddress: null,
        })
      }
    } if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      let lstData = _thisOther.DataVendor.filter(s => s.VENDOR_CODE == event.item.VENDOR_CODE)[0];
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        let taxID = "";
        if (lstData != "") {
          if (lstData.TAX_NUMBER3 != null) {
            taxID = lstData.TAX_NUMBER3
          } else if (lstData.TAX_NUMBER3 == null && lstData.TAX_NUMBER2 != null) {
            taxID = lstData.TAX_NUMBER2;
          } else {
            taxID = lstData.TAX_NUMBER1;
          }
        }
        let str;
        if (event.item.VENDOR_CODE != null) {
          let isonetime = event.item.IsOnetimeVendor;
          if (isonetime) {
            str = 11;
          } else {
            str = 10
          }
        }
        if (str == 10) {
          if (_IsNullOrEmpty(lstData.VENDORNAME) || _IsNullOrEmpty(lstData.ADDRESS)) {
            _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
            return false;
          }
        }
        let Amp = _thisOther._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _thisOther._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _thisOther._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];

        let Type: any;
        let type = event.item.VENDOR_CODE != undefined && event.item.VENDOR_CODE != "" ? event.item.VENDOR_CODE : null;
        if (type != null) {
          let stype = type.substring(0, 2);
          if (stype == "PX") {
            Type = 11;
            _thisOther.IsVendorOneTime = true;
          } else if (stype == "PF") {
            Type = 10;
          }
        }
        let tax = ""
        if (_thisOther.IsVendorOneTime == true) {
          tax = lstData.TAX_ID == null ? "" : lstData.TAX_ID
        }
        if (_thisOther.IsVendorOneTime == false && Type != 11) {
          tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID
        }
        let address = ""
        if (_thisOther.IsVendorOneTime == true) {
          address = lstData.ADDRESS == null ? "" : lstData.ADDRESS
        }
        if (_thisOther.IsVendorOneTime == false && Type != 11) {
          address = lstData.ADDRESS == null ? "-" : lstData.ADDRESS
        }

        invoice.IsVendorOneTime = lstData.IsOnetimeVendor;
        invoice.sVendorCode = lstData.VENDOR_CODE;
        invoice.sTAXID = tax;
        invoice.sVendorName = _thisOther.IsVendorOneTime == true ? "" : lstData.VENDORNAME;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sVendorBranch = lstData.sBranch;
        invoice.sVendorAddress = address;
        invoice.sCountryID = _thisOther.IsVendorOneTime == true || lstData.sCountryID == null ? "213" : lstData.sCountryID;
        invoice.sProvCode = _thisOther.IsVendorOneTime == true || lstData.sProvCode == null ? "" : prov.sProvCode;
        invoice.sProvName = _thisOther.IsVendorOneTime == true || prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sAmpCode = _thisOther.IsVendorOneTime == true || lstData.sAmpCode == null ? "" : Amp.sAmpCode;
        invoice.sAmpName = _thisOther.IsVendorOneTime == true || Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonCode = _thisOther.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : tumbon.sTumbonCode;
        invoice.sTumbonName = _thisOther.IsVendorOneTime == true || tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sPostCode = _thisOther.IsVendorOneTime == true || lstData.sPostCode == null ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = _thisOther.IsVendorOneTime == true || lstData.TEL == null ? "" : lstData.TEL;
        invoice.sFaxNumber = _thisOther.IsVendorOneTime == true || lstData.sFaxNumber == null ? "" : lstData.sFaxNumber;
        invoice.sVendorEmail = _thisOther.IsVendorOneTime == true || lstData.sEMAIL == null ? "" : lstData.sEMAIL;
        // invoice.sAddressOneTime = data.sAddressOneTime;
      })
    }
  }
  //#region "Onetime"
 
  async OnCountryselect(event) {
    if (event.item.sCountryID != "213") {
      this._ArrProvince = [];
      this.isThai = true;
      this.paytoOtherForm.patchValue({
        sCountryID: event.item.sCountryID,
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })

    } else {
      //ProvCode
      await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
        if (res) {
          this._ArrProvince = res;
        }
      });
      this.isThai = true;
      this.paytoOtherForm.patchValue({
        sCountryID: event.item.sCountryID,
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    }
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sCountryID = event.item.sCountryID == null ? "" : event.item.sCountryID;
      })
    }
  }
  OnChangeAmphor(event) {
    let txtsProvName = this.paytoOtherForm.get('sProvName').value
    //Amphur
    this._ArrTumbon = [];
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sProvCode", event.item.sProvCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        this._ArrAmphur = res;
      } else {
        this._ArrAmphur = [];
      }
    });
    if ((this.paytoOtherForm.get('sCountryID').value != "213" || this.sAmphorNoResult == false) && !_IsNullOrEmpty(txtsProvName)) {
      this.paytoOtherForm.patchValue({
        sProvName: event.value,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sProvName = event.value;
          invoice.sProvCode = isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode;
        })
      }
    } else if (this.sAmphorNoResult == true && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sProvName: null,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
    } else if (this.sAmphorNoResult == false && _IsNullOrEmpty(txtsProvName) && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sProvName: null,
        sProvCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย----------------------
    this.paytoOtherForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,
      sAmpName: null,
      sAmpCode: null,
    });
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
        invoice.sAmpName = null
        invoice.sAmpCode = null
      })
    }
  }
  //Amphur
  OnChangeTumbon(event) {
    let txtsAmpName = this.paytoOtherForm.get('sAmpName').value
    //Tumbon
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", event.item.sAmpCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        this._ArrTumbon = res;
      } else {
        this._ArrTumbon = [];
      }
    });
    if ((this.paytoOtherForm.get('sCountryID').value != "213" || this.sTumbonNoResult == false) && !_IsNullOrEmpty(txtsAmpName)) {
      this.paytoOtherForm.patchValue({
        sAmpName: event.value,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sAmpName = event.value;
          invoice.sAmpCode = isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode;
        })
      }
    }
    else if (this.sTumbonNoResult == true && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sAmpName: null,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
    }
    else if (this.sTumbonNoResult == false && _IsNullOrEmpty(txtsAmpName) && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sAmpName: null,
        sAmpCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย------
    this.paytoOtherForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,

    });
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
      })
    }
  }
  OnChangeSubDistrict(event) {
    let txtsTumbonName = this.paytoOtherForm.get('sTumbonName').value

    if ((this.paytoOtherForm.get('sCountryID').value != "213" || this.sSubDistrictNoResult == false) && !_IsNullOrEmpty(txtsTumbonName)) {
      this.paytoOtherForm.patchValue({
        sTumbonName: event.value,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sTumbonName = event.value;
          invoice.sTumbonCode = isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode;
        })
      }
    } else if (this.sSubDistrictNoResult == true && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sTumbonName: null,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
    }
    else if (this.sSubDistrictNoResult == false && _IsNullOrEmpty(txtsTumbonName) && this.paytoOtherForm.get('sCountryID').value == "213") {
      this.paytoOtherForm.patchValue({
        sTumbonName: null,
        sTumbonCode: null,
      });
    }
  }
  async VendorNameChange(event) {
    let _thisOther = this;
    let lstData = event.item;
    let check = this.DataVendorAll.filter(f => f.VENDORNAME == lstData.sVendorName && f.TAX_ID == lstData.TAX_NUMBER1)[0];
    let sVendorName = this.paytoOtherForm.get('sVendorName').value;
    lstData = check;
    if (check != null && !_IsNullOrEmpty(sVendorName)) {
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
      let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
      let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
      let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
      let value = { sCountryID: lstData.sCountryID == null ? "" : lstData.sCountryID };
      let event = { item: value };
      await this.OnCountryselect(event).then();
      this.paytoOtherForm.patchValue({
        sTAXID: _IsNullOrEmpty(lstData.TAX_ID) ? "" : lstData.TAX_ID,
        sAddress: lstData.ADDRESS == null ? "" : lstData.ADDRESS,
        sBankAccountName: _thisOther.paytoOtherForm.get('cbChequeType').value == "C" ? "" : lstData.sVendorName,
        sPhoneNumber: lstData.TEL,
        cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
        sAmpCode: lstData.sAmpCode == null ? "" : lstData.sAmpCode,
        sAmpName: isNullOrUndefined(Amp) == true ? lstData.sAmpName : Amp.sAmpName,
        sBranch: lstData.sBranch,
        sComcode: lstData.sComcode,
        sCountryID: isNullOrUndefined(lstData.sCountryID) == true ? "213" : lstData.sCountryID,
        txtCountryID: isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
        sVendorEmail: lstData.sEMAIL,
        sFaxNumber: lstData.sFaxNumber,
        sPostCode: lstData.sPostCode,
        sProvCode: lstData.sProvCode == null ? "" : lstData.sProvCode,
        sProvName: isNullOrUndefined(prov) == true ? lstData.sProvName : prov.sProvname,
        sTumbonCode: lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
        sTumbonName: isNullOrUndefined(tumbon) == true ? lstData.sTumbonName : tumbon.sTumbonName
      });
      if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
        this.paytoOtherForm.controls['sBranch'].disable();
      }
      if (lstData.sCountryID != "213") {
        let sfield = ["sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sProvName", "sAmpName", "sTumbonName"]
        //sfield.forEach(function (value) {
        //  _thisOther.paytoOtherForm.controls[value].disable();
        //  _thisOther.paytoOtherForm.controls[value].clearValidators();
        //  _thisOther.paytoOtherForm.controls[value].setValidators(null);
        //  _thisOther.paytoOtherForm.controls[value].setErrors({ 'invalid': false });
        //  _thisOther.paytoOtherForm.controls[value].markAsUntouched({ onlySelf: true });
        //  _thisOther.paytoOtherForm.controls[value].updateValueAndValidity();

        //})
      } else {
        this.isThai = true;
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        // "sPostCode", "sPhoneNumber", "sFaxNumber",
        //  this.isThai = false;
        sfield.forEach(function (value) {
          _thisOther.paytoOtherForm.controls[value].enable();
          _thisOther.paytoOtherForm.controls[value].setValidators([Validators.required]);
          _thisOther.paytoOtherForm.controls[value].updateValueAndValidity();
        })
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"]
        sfieldS.forEach(function (value) {
          _thisOther.paytoOtherForm.controls[value].enable();
          _thisOther.paytoOtherForm.controls[value].updateValueAndValidity();
        })
        _thisOther.paytoOtherForm.controls["sVendorEmail"].enable();
        _thisOther.paytoOtherForm.controls["sVendorEmail"].setValidators(Validators.email);
        _thisOther.paytoOtherForm.controls["sVendorEmail"].updateValueAndValidity();
      } if (lstData.sCountryID == null && this.IsVendorOneTime == true) {
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        //  "sPostCode", "sPhoneNumber", "sFaxNumber",
        //  this.isThai = false;
        sfield.forEach(function (value) {
          _thisOther.paytoOtherForm.controls[value].enable();
          _thisOther.paytoOtherForm.controls[value].setValidators([Validators.required]);
          _thisOther.paytoOtherForm.controls[value].updateValueAndValidity();
        })
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"]
        sfieldS.forEach(function (value) {
          _thisOther.paytoOtherForm.controls[value].enable();
          _thisOther.paytoOtherForm.controls[value].updateValueAndValidity();
        })
        _thisOther.paytoOtherForm.controls["sVendorEmail"].enable();
        _thisOther.paytoOtherForm.controls["sVendorEmail"].setValidators(Validators.email);
        _thisOther.paytoOtherForm.controls["sVendorEmail"].updateValueAndValidity();
        this.isThai = true;
        this.paytoOtherForm.patchValue({
          txtCountryID: "ประเทศไทย (Thailand)",
          sCountryID: "213",
          sProvCode: "",
          sAmpCode: "",
          sTumbonCode: "",
          sPostCode: "",
          sPhoneNumber: "",
          sFaxNumber: "",
          sVendorEmail: "",
          sAddressOneTime: "",
        })
        //ProvCode
        await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
          if (res) {
            this._ArrProvince = res;
          }
        });
      }
    } else {
      lstData = {};
      this.paytoOtherForm.patchValue({
        txtCountryID: "ประเทศไทย (Thailand)",
        sTAXID: null,
        cbOffice: 1,
        sBranch: null,
        sAddress: null,
        sCountryID: "213",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    } if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        //if (_IsNullOrEmpty(lstData.VENDORNAME) || _IsNullOrEmpty(lstData.ADDRESS) || _IsNullOrEmpty(lstData.TAX_ID)) {
        //  _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
        //  // return false;
        //}
        let Amp = _thisOther._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _thisOther._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _thisOther._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];

        invoice.sTAXID = _IsNullOrEmpty(lstData.TAX_ID) ? "" : lstData.TAX_ID;
        invoice.sVendorName = isNullOrUndefined(lstData.sVendorName) ? event.value : lstData.sVendorName;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sVendorBranch = isNullOrUndefined(lstData.sBranch) ? "" : lstData.sBranch;
        invoice.sVendorAddress = isNullOrUndefined(lstData.ADDRESS) ? "" : lstData.ADDRESS;
        invoice.sCountryID = isNullOrUndefined(lstData.sCountryID) ? "213" : lstData.sCountryID;
        invoice.sProvCode = isNullOrUndefined(lstData.sProvCode) ? "" : prov.sProvCode;
        invoice.sProvName = prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sAmpCode = isNullOrUndefined(lstData.sAmpCode) ? "" : Amp.sAmpCode;
        invoice.sAmpName = Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonCode = isNullOrUndefined(lstData.sTumbonCode) ? "" : tumbon.sTumbonCode;
        invoice.sTumbonName = tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sPostCode = isNullOrUndefined(lstData.sPostCode) ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = isNullOrUndefined(lstData.TEL) ? "" : lstData.TEL;
        invoice.sFaxNumber = isNullOrUndefined(lstData.sFaxNumber) ? "" : lstData.sFaxNumber;
        invoice.sVendorEmail = isNullOrUndefined(lstData.sEMAIL) ? "" : lstData.sEmail;
        // invoice.sAddressOneTime = data.sAddressOneTime;

      })
    }
    if (this.IsVendorOneTime == true) {
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.value == null ? "" : event.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
    if (this.IsVendorOneTime == false) {
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.target.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.target.value == null ? "" : event.target.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
  }
  CommentChange(event) {
    this.paytoOtherForm.patchValue({
      sComment: event.target.value,
    });

    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.paytoOtherForm.patchValue({
      sCommentSSC: event.target.value,
    });

    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }
  TAXIDChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTAXID = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  AddressChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorAddress = event.target.value == null ? "" : event.target.value;
      })
    }
  }

  BranchChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorBranch = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  PostCodeChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPostCode = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  PhoneNumberChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPhoneNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  FaxNumberChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sFaxNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  EmailChange(event) {
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorEmail = event.target.value == null ? "" : event.target.value;
      })
    }

  }
  //#region "Onetime"


  formatnumber(Digit: number, Grouping: boolean, Data: number): string {
    var currencyChars = new RegExp('[\,]', 'g');

    if (isNaN(Data)) {
      return null;
    } else {
      var item = parseFloat(String(Data).replace(currencyChars, ''));
      return new Intl.NumberFormat('en', { maximumFractionDigits: Digit, minimumFractionDigits: Digit, useGrouping: Grouping }).format(item);
    }
  }

  //#endregoin
  keyPress(event: any, byTotal) {
    let Total: number = _ParseFloatToZero(this.paytoOtherForm.value.nTotalAmountVat)
    let Vat: number = this.paytoOtherForm.value.nVat == null ? 0 : this.paytoOtherForm.value.nVat;
    let WHTRate: number = this.paytoOtherForm.value.nWHTRate
    let WHTRate2: number = this.paytoOtherForm.value.nWHTRate2
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    let nTotalAmountInvoice = this._ConvertToDecimal(include);
    this.paytoOtherForm.patchValue({
      nTotalAmountInvoice: nTotalAmountInvoice,
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })

    let WHTBase: number = 0;
    let WHTBase2: number = 0;
    
    if (WHTRate !== null && WHTRate !== 0) {
      if (byTotal) {
        WHTBase = Number(Total);
      }
      else {
        let nWHTBase: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase'].value).toFixed(2);
        WHTBase = Number(nWHTBase);
      }
    }
    
    let nWHTBase2: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase2'].value).toFixed(2);
    WHTBase2 = Number(nWHTBase2);

    let WHTAmount: number = WHTBase * WHTRate / 100;
    let WHTAmount2: number = WHTBase2 * WHTRate2 / 100;

    this.paytoOtherForm.patchValue({
      nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      _nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      _nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      nWHTBase: this._ConvertToDecimal(WHTBase.toFixed(2)),
      nWHTBase2: this._ConvertToDecimal(WHTBase2.toFixed(2)),
    })
  }
  keyVat(event: any) {
    let Total: number = _ParseFloatToZero(this.paytoOtherForm.value.nTotalAmountVat)
    let include = this.formatnumber(2, true, Total + Number(event.target.value));
    let nTotalAmountInvoice = this._ConvertToDecimal((Number(Total) + Number(event.target.value)).toFixed(2));
    this.paytoOtherForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
    })
  }
  KeyWithholdingRate(event: any, mode: number) {
    let WHYRate: number = event.target.value;
    
    if (mode === 1) {
    let Total: number = _ParseFloatToZero(this.paytoOtherForm.value.nWHTBase).toFixed(2)
    let nWHTVal = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytoOtherForm.patchValue({
        WHYRate: WHYRate,
        nWHTVal: nWHTVal,
        _nWHTVal: nWHTVal,
      });
      if (WHYRate){
        this.paytoOtherForm.patchValue({
          nWHTRate: WHYRate,
        });
      }
    }
    else{
    let Total: number = _ParseFloatToZero(this.paytoOtherForm.value.nWHTBase2).toFixed(2)
    let nWHTVal2 = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytoOtherForm.patchValue({
        WHYRate2: WHYRate,
        nWHTVal2: nWHTVal2,
        _nWHTVal2: nWHTVal2,
      });
      if (WHYRate){
        this.paytoOtherForm.patchValue({
          nWHTRate2: WHYRate,
        });
      }
    }
   
  }

  KeyWithholdingAmount(mode: number){
    const _this = this;
    let ddlWithholdingTax = _this.paytoOtherForm.value.ddlWithholdingTax;
    if (ddlWithholdingTax !== '0' && ddlWithholdingTax !== 0) {
      let nWHTVal: number = 0;
      let _nWHTVal: number = 0;
      let nWHTValNew: any;
      let _nWHTValNew: any;
      if (mode === 1) {
          nWHTVal = Number(_ParseFloatToZero(_this.paytoOtherForm.value.nWHTVal).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytoOtherForm.value._nWHTVal).toFixed(2));
          nWHTValNew = _this.paytoOtherForm.value.nWHTVal;
          _nWHTValNew = _this.paytoOtherForm.value._nWHTVal;
      }
      else {
          nWHTVal = Number(_ParseFloatToZero(_this.paytoOtherForm.value.nWHTVal2).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytoOtherForm.value._nWHTVal2).toFixed(2));
          nWHTValNew = this.paytoOtherForm.value.nWHTVal2;
          _nWHTValNew = this.paytoOtherForm.value._nWHTVal2;
      }
      if (Math.abs(nWHTVal - _nWHTVal) > 1){
        nWHTValNew = _nWHTValNew;
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Error_Amount, null)
      }
      if (mode === 1) {
        _this.paytoOtherForm.patchValue({
          nWHTVal: nWHTValNew,
          _nWHTVal: _nWHTValNew,
        });
      }
      else {
        _this.paytoOtherForm.patchValue({
          nWHTVal2: nWHTValNew,
          _nWHTVal2: _nWHTValNew,
        })
      }
    }
  }

  KeyWithholding(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytoOtherForm.patchValue({
          nWHTVal: '0.00',
          _nWHTVal: '0.00',
        });
      }
      else {
        this.paytoOtherForm.patchValue({
          nWHTVal2: '0.00',
          _nWHTVal2: '0.00',
        })
      }
    }
  }

  KeyWithholdingBase(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytoOtherForm.patchValue({
          nWHTBase: '0.00',
        });
      }
      else {
        this.paytoOtherForm.patchValue({
          nWHTBase2: '0.00',
        })
      }
    }
  }

  onWithholdingTaxSelect(mode: number, isEdit: boolean) {
    if (mode === 1) {
      let ddlWithholdingTax = this.paytoOtherForm.value.ddlWithholdingTax;
      let nWHTBase = _ParseFloatToZero(this.paytoOtherForm.value.nWHTBase).toFixed(2);
      let nWHTVal: number = 0;
      let nWHTOther: number = null;
      let nWHTRate = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      let nWHT = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      if (nWHTRate != null) {
        nWHTRate = nWHTRate.nRate;
      } else {
        nWHTRate = 0;
      }
      if (nWHTRate !== 0) {
        if(nWHTBase === '0.00' || nWHTBase === ''){
          this.paytoOtherForm.patchValue({
            nWHTBase: this._ConvertToDecimal((_ParseFloatToZero(this.paytoOtherForm.value.nTotalAmountVat)).toFixed(2)),
          });
          nWHTBase = _ParseFloatToZero(this.paytoOtherForm.value.nWHTBase).toFixed(2);
        }
      }

      let IsWithholdingTax = nWHTRate == 0 ? true : false;
      if (nWHTRate === 0) IsWithholdingTax = true;
      if (IsWithholdingTax == true && ddlWithholdingTax !== " ") {
        nWHTOther = nWHTRate;
        this.paytoOtherForm.controls['nWHTOther'].enable();
        this.paytoOtherForm.controls['nWHTOther'].setValidators([Validators.required]);
        this.paytoOtherForm.controls['nWHTOther'].setErrors({ 'invalid': true });
        this.paytoOtherForm.controls['nWHTOther'].updateValueAndValidity();
        // if (ddlWithholdingTax === '0' || ddlWithholdingTax === 0) {
        //   this.paytoOtherForm.controls['nWHTVal'].enable();
        //   this.paytoOtherForm.controls['nWHTVal'].setValidators([Validators.required]);
        //   this.paytoOtherForm.controls['nWHTVal'].setErrors({ 'invalid': true });
        //   this.paytoOtherForm.controls['nWHTVal'].updateValueAndValidity();
        // }
        // else {
        //   this.paytoOtherForm.controls['nWHTVal'].disable();
        //   this.paytoOtherForm.controls['nWHTVal'].clearValidators();
        //   this.paytoOtherForm.controls['nWHTVal'].setValidators(null);
        //   this.paytoOtherForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        //   this.paytoOtherForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        //   this.paytoOtherForm.controls['nWHTVal'].updateValueAndValidity();
        // }
      } else if (IsWithholdingTax == false || ddlWithholdingTax == " ") {
        this.paytoOtherForm.controls['nWHTOther'].disable();
        this.paytoOtherForm.controls['nWHTOther'].clearValidators();
        this.paytoOtherForm.controls['nWHTOther'].setValidators(null);
        this.paytoOtherForm.controls['nWHTOther'].setErrors({ 'invalid': false });
        this.paytoOtherForm.controls['nWHTOther'].markAsUntouched({ onlySelf: true });
        this.paytoOtherForm.controls['nWHTOther'].updateValueAndValidity();
        // this.paytoOtherForm.controls['nWHTVal'].disable();
        // this.paytoOtherForm.controls['nWHTVal'].clearValidators();
        // this.paytoOtherForm.controls['nWHTVal'].setValidators(null);
        // this.paytoOtherForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        // this.paytoOtherForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        // this.paytoOtherForm.controls['nWHTVal'].updateValueAndValidity();
        nWHTVal = Number(nWHTBase * (nWHTRate / 100));
      }
      if (isEdit) {
        this.paytoOtherForm.patchValue({
          nWHTID: nWHT == undefined ? null : nWHT.nWHTID,
          nWHTRate: nWHTRate,
          nWHTOther: nWHTOther,
          nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
          _nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
        });
      }
    }
    else{
      let ddlWithholdingTax2 = this.paytoOtherForm.value.ddlWithholdingTax2;
      let nWHTBase2 = _ParseFloatToZero(this.paytoOtherForm.value.nWHTBase2).toFixed(2);
      let nWHTVal2: number = 0;
      let nWHTOther2: number = null;
      let nWHTRate2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      if (nWHTRate2 != null) {
        nWHTRate2 = nWHTRate2.nRate;
      } else {
        nWHTRate2 = 0;
      }
      let IsWithholdingTax2 = nWHTRate2 == 0 ? true : false;
      if (nWHTRate2 === 0) IsWithholdingTax2 = true;
      if (IsWithholdingTax2 == true && ddlWithholdingTax2 !== " ") {
        nWHTOther2 = nWHTRate2;
        this.paytoOtherForm.controls['nWHTOther2'].enable();
        this.paytoOtherForm.controls['nWHTOther2'].setValidators([Validators.required]);
        this.paytoOtherForm.controls['nWHTOther2'].setErrors({ 'invalid': true });
        this.paytoOtherForm.controls['nWHTOther2'].updateValueAndValidity();
        if (ddlWithholdingTax2 === '0' || ddlWithholdingTax2 === 0) {
          this.paytoOtherForm.controls['nWHTVal2'].enable();
          this.paytoOtherForm.controls['nWHTVal2'].setValidators([Validators.required]);
          this.paytoOtherForm.controls['nWHTVal2'].setErrors({ 'invalid': true });
          this.paytoOtherForm.controls['nWHTVal2'].updateValueAndValidity();
        }
        else {
          this.paytoOtherForm.controls['nWHTVal2'].disable();
          this.paytoOtherForm.controls['nWHTVal2'].clearValidators();
          this.paytoOtherForm.controls['nWHTVal2'].setValidators(null);
          this.paytoOtherForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
          this.paytoOtherForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
          this.paytoOtherForm.controls['nWHTVal2'].updateValueAndValidity();
        }
      } else if (IsWithholdingTax2 == false || ddlWithholdingTax2 == " ") {
        this.paytoOtherForm.controls['nWHTOther2'].disable();
        this.paytoOtherForm.controls['nWHTOther2'].clearValidators();
        this.paytoOtherForm.controls['nWHTOther2'].setValidators(null);
        this.paytoOtherForm.controls['nWHTOther2'].setErrors({ 'invalid': false });
        this.paytoOtherForm.controls['nWHTOther2'].markAsUntouched({ onlySelf: true });
        this.paytoOtherForm.controls['nWHTOther2'].updateValueAndValidity();
        this.paytoOtherForm.controls['nWHTVal2'].disable();
        this.paytoOtherForm.controls['nWHTVal2'].clearValidators();
        this.paytoOtherForm.controls['nWHTVal2'].setValidators(null);
        this.paytoOtherForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
        this.paytoOtherForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
        this.paytoOtherForm.controls['nWHTVal2'].updateValueAndValidity();
        nWHTVal2 = Number(nWHTBase2 * (nWHTRate2 / 100));
      }
      if (isEdit) {
        this.paytoOtherForm.patchValue({
          nWHTID2: nWHT2 == undefined ? null : nWHT2.nWHTID,
          nWHTRate2: nWHTRate2,
          nWHTOther2: nWHTOther2,
          nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
          _nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
        });
      }
    }
   
  }
  onGLSelect(row) {
    this.sGL = this.ArrGL.value.sGL
  }
  async onCostCenterSelect(sCost, row) {
    let _thisOther = this;
    if (sCost != undefined && sCost != "") {
      let lstData = this.DataCostCenter.filter(s => s.COST_CENTER == sCost)[0]
      let nCostCode = lstData.COST_CENTER;
      const httpOptions_IO = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sCompCode", this.nComcode)
      };

      //AutocompleteIO
      await this.http.get(_thisOther.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then((data: Response) => {
        this.DataIO = data;
        if (this.DataIO != null) {
          this.ArrMaster[row] = this.DataIO;
        } else {
          this.ArrMaster[row] = ["", ""];
        }
      })
    }
  }
  Onbankother(value) {
    if (value.target.value == "Other, please specify") {
      this.hidbankother = false;
      this.paytoOtherForm.controls["BankOther"].enable()
      this.paytoOtherForm.controls["BankOther"].markAsTouched({ onlySelf: true });
      this.paytoOtherForm.controls["BankOther"].setValidators([Validators.required]);
      this.paytoOtherForm.controls["BankOther"].updateValueAndValidity();
    } else {
      this.paytoOtherForm.patchValue({ BankOther: null })
      this.hidbankother = true;
      this.paytoOtherForm.controls["BankOther"].clearValidators();
      this.paytoOtherForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls["BankOther"].setValidators([]);
      this.paytoOtherForm.controls["BankOther"].setErrors(null);
      this.paytoOtherForm.controls["BankOther"].updateValueAndValidity();
      this.paytoOtherForm.controls["BankOther"].disable()
    }
  }
  async AddInvoice() {
    let _this = this;
    if (_IsNullOrEmpty(_this.paytoOtherForm.get('sVendorName').value) || _IsNullOrEmpty(_this.paytoOtherForm.get('sAddress').value) || _IsNullOrEmpty(_this.paytoOtherForm.get('sTAXID').value)) {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
      return false;
    }
    let nTotalAmountVat: number = _ParseFloatToZero(this.paytoOtherForm.controls['nTotalAmountVat'].value).toFixed(2);
    let nWHTBase: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase'].value).toFixed(2);
    let nWHTBase2: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase2'].value).toFixed(2);

    let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
    let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));

    if (totalAmount !== base && base !== '0.00') {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
      return false;
    }

    //#region CheckValidate
    let vatType = this.paytoOtherForm.value.ddVatType;
    let datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
    let _FormGroup = this.paytoOtherForm;
    let IsValid: boolean = true;
    let FieldValid: string[];
    if (_FormGroup.get("nWHTOther").disabled == true || _FormGroup.get("nWHTOther2").disabled == true) {
      //FieldValid = ["sAddress", "sVendorName", "sTAXID", "sInvoiceNo", "sName", "dDueDate", "nVendorCode",
      //  , "dInvoiceDate", "nTotalAmountVat", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"
      //  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail",];
      FieldValid = ["sAddress", "sVendorName", "sTAXID", "sInvoiceNo", "sName", "dDueDate", "nVendorCode",
        , "dInvoiceDate", "nTotalAmountVat", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
      //"sCountryID", "sProvName", "sAmpName", "sTumbonName", "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"
    } else {
      //FieldValid = ["sAddress", "sInvoiceNo", "sName", "dDueDate", "nVendorCode", "sVendorName", "sTAXID",
      //  , "dInvoiceDate", "nTotalAmountVat", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"
      //  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail", "nWHTOther"];
      FieldValid = ["sAddress", "sInvoiceNo", "sName", "dDueDate", "nVendorCode", "sVendorName", "sTAXID",
        , "dInvoiceDate", "nTotalAmountVat", "nWHTOther", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
      // "sCountryID", "sProvName", "sAmpName", "sTumbonName"  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail",
    }
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled != true) {
        IsValid = false;
        return false;
      }
      //เช็ค ddTypeVat
      if (vatType != "-1") {
        if (!_FormGroup.get("nVatAmount").valid && datavat.TAX_CODE != "VZ") {
          const control = _FormGroup.get("nVatAmount");
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            IsValid = false;
            return false;
          }
        }
      } else if (vatType == "-1") {
        const control = _FormGroup.get("nVatAmount");
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
          _FormGroup.get("ddVatType").setErrors({ 'invalid': true })
          _FormGroup.get("ddVatType").markAsTouched({ onlySelf: true });
          IsValid = false;
          return false;
        }
      }
    });

    //เช็ค ArrGL
    if (IsValid) {
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            IsValid = false;
            return false;
          }
        });
      }
    }
    //#endregion
    if (IsValid) {
      let nWHTRate: any;
      let nWHTRate2: any;
      let arrGl = this.paytoOtherForm.value.ArrGL;
      let InvoiceNo = this.paytoOtherForm.get('sInvoiceNo').value;
      let VatType = this.paytoOtherForm.get('ddVatType').value;
      let sVendorCode = this.paytoOtherForm.get('nVendorCode').value;
      let sVendorName = this.paytoOtherForm.get('sVendorName').value;
      let sTAXID = this.paytoOtherForm.get('sTAXID').value;
      let sVendorBranch = this.paytoOtherForm.get('sBranch').value;
      let sVendorAddress = this.paytoOtherForm.get('sAddress').value;
      let dInvoiceDate = this.datepipe.transform(this.paytoOtherForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
      let sCurrency = this.paytoOtherForm.get('ddCurrency').value;
      let nExcludeVAT = Number(this.paytoOtherForm.get('nTotalAmountVat').value).toFixed(2);
      let nVatAmount = this.paytoOtherForm.get('nVatAmount').value;
      let nIncludeVAT = this.paytoOtherForm.get('nTotalAmountInvoice').value;
      let nWHTID = this.paytoOtherForm.get('ddlWithholdingTax').value;
      let nWHTID2 = this.paytoOtherForm.get('ddlWithholdingTax2').value;
      let nWHT = this.WHT.filter(f => f.nRate == nWHTID && nWHTID !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == nWHTID2 && nWHTID2 !== ' ')[0];
      let nWHTVal = this.paytoOtherForm.get('nWHTVal').value;
      let nWHTVal2 = this.paytoOtherForm.get('nWHTVal2').value;
      let nWHTBase = this.paytoOtherForm.get('nWHTBase').value;
      let nWHTBase2 = this.paytoOtherForm.get('nWHTBase2').value;
      let sCountryID = this.paytoOtherForm.get('sCountryID').value;
      let sProvCode = this.paytoOtherForm.get('sProvCode').value;
      let sProvName = this.paytoOtherForm.get('sProvName').value;
      let sAmpCode = this.paytoOtherForm.get('sAmpCode').value;
      let sAmpName = this.paytoOtherForm.get('sAmpName').value;
      let sTumbonCode = this.paytoOtherForm.get('sTumbonCode').value;
      let sTumbonName = this.paytoOtherForm.get('sTumbonName').value;
      let sPostCode = this.paytoOtherForm.get('sPostCode').value;
      let sPhoneNumber = this.paytoOtherForm.get('sPhoneNumber').value;
      let sFaxNumber = this.paytoOtherForm.get('sFaxNumber').value;
      let sVendorEmail = this.paytoOtherForm.get('sVendorEmail').value;
      let sAddressOneTime = this.paytoOtherForm.get('sAddressOneTime').value;
      let nOfficeType = this.paytoOtherForm.value.cbOffice;
      let IsVendorOneTime = this.IsVendorOneTime;
      if (nWHTID == '99' || nWHTID == '0') {
        nWHTRate = Number(this.paytoOtherForm.get('nWHTOther').value);
      }
      else if (nWHTID == ' ') {
        nWHTRate = null;
      }
      else {
        nWHTRate = Number(this.paytoOtherForm.get('nWHTRate').value);
      }
      if (nWHTID2 == '99' || nWHTID2 == '0') {
        nWHTRate2 = Number(this.paytoOtherForm.get('nWHTOther2').value);
      }
      else if (nWHTID2 == ' ') {
        nWHTRate2 = null;
      }
      else {
        nWHTRate2 = Number(this.paytoOtherForm.get('nWHTRate2').value);
      }
      let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => this.Check2Digit(m.sAmountExcludedVAT));
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
      let _this = this;
      let isDup: Boolean;
      let checkDupInvoiceinBase = await this.checkDupinBase(InvoiceNo, dInvoiceDate)
      isDup = (checkDupInvoiceinBase == "Dup") ? true : false
      let CheckDupInvoice = this.ArrInvoiceOther.filter(m =>
        (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
      )

      if (CheckDupInvoice.length == 0 && isDup == false) {
        if (sumNumber == Number(_ParseFloatToZero(this.paytoOtherForm.value.nTotalAmountVat).toFixed(2))) {
          let checkGL = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sGL,
          )
          let checkCostCenter = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sCostCenter,
          )
          let checkIO = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sIO,
          )
          /*          if ((checkGL.includes("") == false && checkCostCenter.includes("") == false && checkIO.includes("") == false)) {*/
          let wht: any;
          let wht2: any;
          if (nWHT == undefined || nWHT == null) {
            wht = null;
          } 
          if (nWHT2 == undefined || nWHT2 == null) {
            wht2 = null;
          } 
          if (nWHTID == 99) {
            wht = 99;
          } 
          if (nWHTID2 == 99) {
            wht2 = 99;
          } 
          if (nWHT != undefined || nWHT != null) {
            wht = nWHT.nWHTID;
          }
          if (nWHT2 != undefined || nWHT2 != null) {
            wht2 = nWHT2.nWHTID;
          }
          arrGl.filter(f => f.IsDelete != true).forEach(function (value, i: number) {
            let nLine = (_this.ArrInvoiceOther.length >= 1) ? _this.ArrInvoiceOther.filter(f => (f.sInvoiceNo == InvoiceNo && f.dInvoiceDate == dInvoiceDate && f.IsDelete == false)).length : 0;
            let arr = {
              sInvoiceNo: InvoiceNo,
              sVatType: VatType,
              nLine: nLine + 1,
              sGL: value.sGL,
              sCostCenter: value.sCostCenter,
              sIO: value.sIO === "Not Require IO (N/A)" ? null : value.sIO,
              sAmount: _ParseFloatToZero(value.sAmountExcludedVAT),
              sText: value.sText,
              cVenderMaster: "M",
              sVendorCode: sVendorCode,
              sVendorName: sVendorName,
              sTAXID: sTAXID,
              sVendorBranch: sVendorBranch,
              sVendorAddress: sVendorAddress,
              dInvoiceDate: dInvoiceDate,
              sCurrency: sCurrency,
              nExcludeVAT: _ParseFloatToZero(nExcludeVAT),
              nVAT: _ParseFloatToZero(nVatAmount),
              nIncludeVAT: _ParseFloatToZero(nIncludeVAT),
              nWHTID: wht,
              nWHTID2: wht2,
              nWHTRate: +nWHTRate,
              nWHTRate2: +nWHTRate2,
              nWHTVal: _ParseFloatToZero(nWHTVal),
              _nWHTVal: _ParseFloatToZero(nWHTVal),
              nWHTVal2: _ParseFloatToZero(nWHTVal2),
              _nWHTVal2: _ParseFloatToZero(nWHTVal2),
              nWHTBase: _ParseFloatToZero(nWHTBase),
              nWHTBase2: _ParseFloatToZero(nWHTBase2),
              nOfficeType: nOfficeType,
              nInvoiceType: null,
              sCountryID: sCountryID,
              sProvCode: sProvCode,
              sProvName: sProvName,
              sAmpCode: sAmpCode,
              sAmpName: sAmpName,
              sTumbonCode: sTumbonCode,
              sTumbonName: sTumbonName,
              sPostCode: sPostCode,
              sPhoneNumber: sPhoneNumber,
              sFaxNumber: sFaxNumber,
              sVendorEmail: sVendorEmail,
              sAddressOneTime: sAddressOneTime,
              IsVendorOneTime: IsVendorOneTime,
              dCreateDate: null,
              sCreateBy: "",
              dUpdateDate: null,
              IsDelete: false,
            };
            _this.ArrInvoiceOther.push(arr);
          })
          this.CalGrand();
          this.Checkinvoice();
          this.clearSubinvoice();

          //#region 2021-01-21 Log Save Invoice
          // const options = { headers: { 'Content-Type': 'application/json' } };
          // _this.http.post<any>(_this.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_this.ArrInvoice), options).subscribe(res => {

          // })
          //#endregion

          /*    } else {
                this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_info, "!!!!!!!!!", undefined)
              }*/

        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
          return false;
        }
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
      }
    } else {
      FieldValid.forEach(function (Field) {
        const control = _FormGroup.get(Field);             //{3}
        if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
          control.markAsTouched({ onlySelf: true });
        }
      });
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          const control = FromArray.at(i).get(Field);             //{3}
          if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
            control.markAsTouched({ onlySelf: true });
          }
        });
      }
    }
  }
  ClearInvoice() {
    this.paytoOtherForm.controls['nVatAmount'].enable();
    this.paytoOtherForm.controls["nVatAmount"].setValidators([Validators.required]);
    this.paytoOtherForm.controls["nVatAmount"].updateValueAndValidity();
    this.paytoOtherForm.controls['nWHTOther'].disable();
    let _thisOther = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sTAXID", "sVendorName", "sInvoiceNo", "nVendorCode", "dInvoiceDate", "ddVatType", "nTotalAmountVat", "nBankAccountNo", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"
      , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"];
    for (let i = 0; i < FieldValid.length; i++) {
      _thisOther.paytoOtherForm.get(FieldValid[i]).markAsUntouched();
    }
    let sCurrency = _thisOther.ArrInvoiceOther.filter(f => f.IsDelete != true).length > 0 ? _thisOther.paytoOtherForm.get("ddCurrency").value : "THB"
    if (_thisOther.ArrInvoiceOther.filter(f => f.IsDelete != true).length == 0) {
      this.paytoOtherForm.patchValue({
        nVendorCode: "",
        sTAXID: "",
        sVendorName: "",
        cbOffice: 1,
        sBranch: "",
        sAddress: "",
        sCountryID: "",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
      });
    } else {
      this.paytoOtherForm.patchValue({
        //  nVendorCode: "",
        sInvoiceNo: null,
        dInvoiceDate: new Date(),
        nTotalAmount: null,
        ddCurrency: sCurrency,
        nVat: null,
        ddVatType: "-1",
        nVatAmount: null,
        nTotalAmountInvoice: null,
        nTotalAmountVat: null,
        ddlWithholdingTax: " ",
        ddlWithholdingTax2: " ",
        nWHTRate: null,
        nWHTRate2: null,
        nWHTOther: null,
        nWHTOther2: null,
        nWHTVal: null,
        _nWHTVal: null,
        nWHTVal2: null,
        _nWHTVal2: null,
        nWHTBase: null,
        nWHTBase2: null,
        ddBankKey: "",
        nBankKey: "",
        ddBankKey2: "",
        nBankKey2: "",
      })
      this.paytoOtherForm.controls['ddBankKey2'].disable();
    }
    if (this.paytoOtherForm.get('cbOffice').value == 1) {
      this.paytoOtherForm.controls['sBranch'].disable();
    }
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytoOtherForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl(''),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();

  }
  DeleteInvoice(sInvoiceNo, index) {
    let _thisOther = this;
    let del = function () {
      let invoice = _thisOther.ArrInvoiceOther[index]
      invoice.cActive = "N";
      invoice.IsDelete = true;
      invoice.nLine = (invoice.nLine == null) ? 1 : invoice.nLine;

      _thisOther.CalGrand();
      _thisOther.Checkinvoice();
    }
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, del, function () { });
  }
  async EditInvoice(index, save) {
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    let _thisOther = this;
    if (!save) {
      document.getElementById('nVendorCode').scrollIntoView({ behavior: "smooth" });
      this.ArrGL.clear()
      this._paytoOtherForm.ArrGL.reset();
      this.nEditindex = index;
      this.isEdit = true;
      let data = this.ArrInvoiceOther[index];
      let arrData = this.ArrInvoiceOther.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate)
      this.EditInvoiceCode = data.sInvoiceNo;
      this.EditInvoiceDate = data.dInvoiceDate;
      let myDate = data.dInvoiceDate;
      let chunks = myDate.split('/');
      let dInvoiceDate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
      let nVat = '';
      if (this.VatType.filter(s => s.TAX_CODE == data.sVatType).length > 0) {
        nVat = this.VatType.filter(s => s.TAX_CODE == data.sVatType)[0].nVAT;
      }
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", data.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", data.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let nWHT = this.WHT.filter(f => f.nWHTID == data.nWHTID)[0];
      let nWHT2 = this.WHT.filter(f => f.nWHTID == data.nWHTID2)[0];
      let ddlWithholdingTax: any;
      let ddlWithholdingTax2: any;

      if (data.nWHTID == null || data.nWHTID == " " || data.nWHTID == "") {
        ddlWithholdingTax = " ";
      }
      if (data.nWHTID2 == null || data.nWHTID2 == " " || data.nWHTID2 == "") {
        ddlWithholdingTax2 = " ";
      }
      if (data.nWHTID == 99) {
        ddlWithholdingTax = 99;
      }
      if (data.nWHTID2 == 99) {
        ddlWithholdingTax2 = 99;
      }
      if (data.nWHTID != null && data.nWHTID != 99 && data.nWHTID != "null") {
        if (nWHT != undefined) ddlWithholdingTax = nWHT.nRate
      }
      if (data.nWHTID2 != null && data.nWHTID2 != 99 && data.nWHTID2 != "null") {
        if (nWHT2 != undefined) ddlWithholdingTax2 = nWHT2.nRate
      }

      let nWHTRate: any;
      let nWHTRate2: any;
      if (data.nWHTID == "0" || data.nWHTID == null) {
        nWHTRate = null;
      } 
      if (data.nWHTID2 == "0" || data.nWHTID2 == null) {
        nWHTRate2 = null;
      } 
      if (data.nWHTID == 99 || data.nWHTID == 6) {
        nWHTRate = data.nWHTRate
      } 
      if (data.nWHTID2 == 99 || data.nWHTID2 == 6) {
        nWHTRate2 = data.nWHTRate2
      } 
      if ((data.nWHTID != "0" || data.nWHTID != null) && data.nWHTID != 99 && data.nWHTID != 6) {
        nWHTRate = null;
      }
      if ((data.nWHTID2 != "0" || data.nWHTID2 != null) && data.nWHTID2 != 99 && data.nWHTID2 != 6) {
        nWHTRate2 = null;
      }
      this.paytoOtherForm.patchValue({
        nVendorCode: data.sVendorCode,
        sTAXID: data.sTAXID,
        sVendorName: data.sVendorName,
        cbOffice: data.nOfficeType,
        sBranch: data.sVendorBranch,
        sAddress: data.sVendorAddress,
        sCountryID: data.sCountryID,
        sProvCode: data.sProvCode,
        sProvName: data.sProvName,
        sAmpCode: data.sAmpCode,
        sAmpName: data.sAmpName,
        sTumbonCode: data.sTumbonCode,
        sTumbonName: data.sTumbonName,
        sPostCode: data.sPostCode,
        sPhoneNumber: data.sPhoneNumber,
        sFaxNumber: data.sFaxNumber,
        sVendorEmail: data.sVendorEmail,
        sAddressOneTime: data.sAddressOneTime,
        sInvoiceNo: data.sInvoiceNo,
        dInvoiceDate: dInvoiceDate,
        nTotalAmount: data.sAmount,
        ddCurrency: data.sCurrency,
        nVat: nVat,
        ddVatType: data.sVatType,
        nVatAmount: (!isNullOrUndefined(data.nVAT) ? _thisOther._ConvertToDecimal(data.nVAT) : 0),
        nTotalAmountInvoice: (!isNullOrUndefined(data.nIncludeVAT) ? _thisOther._ConvertToDecimal(data.nIncludeVAT) : 0),
        nTotalAmountVat: (!isNullOrUndefined(data.nExcludeVAT) ? _thisOther._ConvertToDecimal(data.nExcludeVAT) : 0),
        ddlWithholdingTax: ddlWithholdingTax,
        ddlWithholdingTax2: ddlWithholdingTax2,
        nWHTRate: data.nWHTRate == 0 ? " " : data.nWHTRate,
        nWHTRate2: data.nWHTRate2 == 0 ? " " : data.nWHTRate2,
        nWHTOther: nWHTRate,
        nWHTOther2: nWHTRate2,
        nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _thisOther._ConvertToDecimal(data.nWHTVal) : '0.00'),
        _nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _thisOther._ConvertToDecimal(data.nWHTVal) : '0.00'),
        nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _thisOther._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        _nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _thisOther._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        nWHTBase: (!isNullOrUndefined(data.nWHTBase) ? _thisOther._ConvertToDecimal(data.nWHTBase) : 0),
        nWHTBase2: (!isNullOrUndefined(data.nWHTBase2) ? _thisOther._ConvertToDecimal(data.nWHTBase2) : 0),
      })
      this.Editsetvat();
      this.onWithholdingTaxSelect(1, false);
      this.onWithholdingTaxSelect(2, false);
      let num = 0;
      arrData.forEach(function (arrGL, i) {
        _thisOther.ArrMaster = [];
        _thisOther.ArrMaster.push(_thisOther.ArrIO);
        _thisOther.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        }))
        _thisOther.ArrGL.at(num).patchValue({
          sGL: arrGL.sGL,
          sCostCenter: arrGL.sCostCenter,
          sIO: arrGL.sIO === null ? "Not Require IO (N/A)" : arrGL.sIO,
          sAmountExcludedVAT: _thisOther._ConvertToDecimal(arrGL.sAmount),
          sText: arrGL.sText,
          IsDelete: arrGL.cActive == "N" ? true : false,
          sInvoiceNo: arrGL.sInvoiceNo,
          nline: arrGL.nLine
        })
        const httpOptions_IO = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sCompCode", _thisOther.nComcode)
        };
        //AutocompleteIO
        _thisOther.http.get(_thisOther.System.SiteName + "api/_System/GetIO2", httpOptions_IO).subscribe((data: Response) => {
          _thisOther.DataIO = data;
          if (_thisOther.DataIO != null) {
            _thisOther.ArrIO = _thisOther.DataIO;
            _thisOther.ArrMaster[i] = _thisOther.ArrIO;
          } else {
            _thisOther.ArrMaster[i] = _thisOther.ArrIO;
          }
        })
        num++;
      });
      this.checkUseIo();
      this.checkUseGL();
      this.CalGrand();
      this.paytoOtherForm.controls['ddCurrency'].enable();
    }
    if (save) {
      let pass = true;
      if (_IsNullOrEmpty(_thisOther.paytoOtherForm.get('sVendorName').value) || _IsNullOrEmpty(_thisOther.paytoOtherForm.get('sAddress').value) || _IsNullOrEmpty(_thisOther.paytoOtherForm.get('sTAXID').value)) {
        _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
        return false;
     
      }
      let nTotalAmountVat: number = _ParseFloatToZero(this.paytoOtherForm.controls['nTotalAmountVat'].value).toFixed(2);
      let nWHTBase: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase'].value).toFixed(2);
      let nWHTBase2: number = _ParseFloatToZero(this.paytoOtherForm.controls['nWHTBase2'].value).toFixed(2);
  
      let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
      let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));
  
      if (totalAmount !== base && base !== '0.00') {
        _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
        return false;
      }
      let _FormGroup = this.paytoOtherForm;
      //    let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT"];
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            pass = false;
            return false;
          }
        });
      }
      if (pass) {
        let dInvoiceDate = this.datepipe.transform(this.paytoOtherForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
        let InvoiceNo = this.paytoOtherForm.get('sInvoiceNo').value;
        let arrGl = this.paytoOtherForm.value.ArrGL;
        let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => this.Check2Digit(m.sAmountExcludedVAT));
        let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
        let isDup: Boolean;
        let checkDupInvoiceinBase = await this.EditcheckDupinBase(InvoiceNo, dInvoiceDate, this.sReqID)
        isDup = (checkDupInvoiceinBase == "Dup") ? true : false
        let tempArr = [];
        this.ArrInvoiceOther.forEach(val => tempArr.push(Object.assign({}, val)));
        while (tempArr.findIndex(e => e.sInvoiceNo === _thisOther.EditInvoiceCode && e.dInvoiceDate === _thisOther.EditInvoiceDate) >= 0)
          tempArr.splice(tempArr.findIndex(f => f.sInvoiceNo === _thisOther.EditInvoiceCode && f.dInvoiceDate === _thisOther.EditInvoiceDate), 1);
        let CheckDupInvoice = tempArr.filter(m =>
          (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
        )
        if (CheckDupInvoice.length == 0 && isDup == false) {
          let _thisOther = this;
          if (sumNumber == Number(_ParseFloatToZero(_thisOther.paytoOtherForm.value.nTotalAmountVat).toFixed(2))) {
            let nWHTRate: any;
            let nWHTRate2: any;
            let data = this.ArrInvoiceOther[index];
            arrGl.forEach(function (value, num) {
              let nline = value.nline;
              let arrData = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == _thisOther.EditInvoiceCode && f.dInvoiceDate == _thisOther.EditInvoiceDate && f.nLine == nline)
              if (arrData.length > 0) {
                arrData.forEach(function (value, i) {
                  value.ntype = _thisOther.paytoOtherForm.get('ntype').value;
                  value.sInvoiceNo = _thisOther.paytoOtherForm.get('sInvoiceNo').value;
                  value.sVatType = _thisOther.paytoOtherForm.get('ddVatType').value;
                  value.sGL = arrGl[num].sGL;
                  value.sCostCenter = arrGl[num].sCostCenter;
                  value.sIO = arrGl[num].sIO === "Not Require IO (N/A)" ? null : arrGl[num].sIO;
                  value.sAmount = _ParseFloatToZero(arrGl[num].sAmountExcludedVAT);
                  value.sText = arrGl[num].sText;
                  value.IsDelete = arrGl[num].IsDelete;
                  value.cActive = arrGl[num].IsDelete == true ? 'N' : 'Y';
                  value.nLine = (nline == null) ? 1 : nline;
                  value.nOfficeType = _thisOther.paytoOtherForm.get('cbOffice').value;
                  value.sVendorCode = _thisOther.paytoOtherForm.get('nVendorCode').value;
                  value.sVendorName = _thisOther.paytoOtherForm.get('sVendorName').value;
                  value.sTAXID = _thisOther.paytoOtherForm.get('sTAXID').value;
                  value.sVendorBranch = _thisOther.paytoOtherForm.get('sBranch').value;
                  value.sVendorAddress = _thisOther.paytoOtherForm.get('sAddress').value;
                  value.dInvoiceDate = _thisOther.datepipe.transform(_thisOther.paytoOtherForm.get('dInvoiceDate').value, 'dd/MM/yyyy');
                  value.sCurrency = _thisOther.paytoOtherForm.get('ddCurrency').value;
                  value.nExcludeVAT = Number(_ParseFloatToZero(_thisOther.paytoOtherForm.value.nTotalAmountVat).toFixed(2));
                  value.nVAT = _ParseFloatToZero(_thisOther.paytoOtherForm.get('nVatAmount').value);
                  value.nIncludeVAT = _ParseFloatToZero(_thisOther.paytoOtherForm.get('nTotalAmountInvoice').value);
                  value.sCountryID = _thisOther.paytoOtherForm.get('sCountryID').value
                  value.sProvCode = _thisOther.paytoOtherForm.get('sProvCode').value;
                  value.sAmpCode = _thisOther.paytoOtherForm.get('sAmpCode').value;
                  value.sTumbonCode = _thisOther.paytoOtherForm.get('sTumbonCode').value;
                  value.sPostCode = _thisOther.paytoOtherForm.get('sPostCode').value;
                  value.sPhoneNumber = _thisOther.paytoOtherForm.get('sPhoneNumber').value;
                  value.sFaxNumber = _thisOther.paytoOtherForm.get('sFaxNumber').value;
                  value.sVendorEmail = _thisOther.paytoOtherForm.get('sVendorEmail').value;
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value != 0) {

                    nWHTRate = Number(_thisOther.paytoOtherForm.get('nWHTRate').value);
                  } else {
                    nWHTRate = Number(_thisOther.paytoOtherForm.get('nWHTOther').value);
                  }
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value != 0) {

                    nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTRate2').value);
                  } else {
                    nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTOther2').value);
                  }
                  let nWHT = _thisOther.WHT.filter(f => f.nRate == _thisOther.paytoOtherForm.get('ddlWithholdingTax').value && _thisOther.paytoOtherForm.get('ddlWithholdingTax').value !== ' ')[0];
                  let nWHT2 = _thisOther.WHT.filter(f => f.nRate == _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value && _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value !== ' ')[0];
                 
                  let nWHTID: any;
                  let nWHTID2: any;
                  if (nWHT == null || nWHT == " " || nWHT == "" || nWHT == undefined) {
                    nWHTID = null;
                    if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    }
                  }
                  else {
                    if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    } if (nWHT != null) {
                      nWHTID = nWHT.nWHTID;
                    }
                  }
                  if (nWHT2 == null || nWHT2 == " " || nWHT2 == "" || nWHT2 == undefined) {
                    nWHTID2 = null;
                    if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    }
                  }
                  else {
                    if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    } if (nWHT2 != null) {
                      nWHTID2 = nWHT2.nWHTID;
                    }
                  }

                  //    let nWHTRate: any;
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value == "0" || _thisOther.paytoOtherForm.get('ddlWithholdingTax').value == null) {
                    nWHTRate = Number(_thisOther.paytoOtherForm.get('nWHTRate').value);
                  } 
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == "0" || _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == null) {
                    nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTRate2').value);
                  } 
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value == 99 || _thisOther.paytoOtherForm.get('ddlWithholdingTax').value == 6) {
                    nWHTRate = Number(_thisOther.paytoOtherForm.get('nWHTOther').value);
                  }
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 99 || _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 6) {
                    nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTOther2').value);
                  }

                  //    value.nWHTID = nWHT == undefined ? null : nWHT.nWHTID + ""
                  value.nWHTID = nWHTID == null ? null : nWHTID;
                  value.nWHTID2 = nWHTID2 == null ? null : nWHTID2;
                  value.nWHTRate = nWHTRate;
                  value.nWHTRate2 = nWHTRate2;
                  value.nWHTVal = _thisOther.paytoOtherForm.get('nWHTVal').value;
                  value.nWHTVal2 = _thisOther.paytoOtherForm.get('nWHTVal2').value;
                  value.nWHTBase = _thisOther.paytoOtherForm.get('nWHTBase').value;
                  value.nWHTBase2 = _thisOther.paytoOtherForm.get('nWHTBase2').value;

                })
              } else {
                let nWHT = _thisOther.WHT.filter(f => f.nRate == _thisOther.paytoOtherForm.get('ddlWithholdingTax').value && _thisOther.paytoOtherForm.get('ddlWithholdingTax').value !== ' ')[0];
                let nWHT2 = _thisOther.WHT.filter(f => f.nRate == _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value && _thisOther.paytoOtherForm.get('ddlWithholdingTax2').value !== ' ')[0];
               
                let nWHTID: any;
                let nWHTID2: any;
                if (nWHT == null || nWHT == " " || nWHT == "") {
                  nWHTID = null;
                }
                else {
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value == 99) {
                    nWHTID = 99;
                  } if (nWHT != null) {
                    nWHTID = nWHT.nWHTID;
                  }
                }
                if (nWHT2 == null || nWHT2 == " " || nWHT2 == "") {
                  nWHTID2 = null;
                }
                else {
                  if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 99) {
                    nWHTID2 = 99;
                  } if (nWHT != null) {
                    nWHTID2 = nWHT.nWHTID;
                  }
                }

                if (_thisOther.paytoOtherForm.get('ddlWithholdingTax').value != 0) {
                  nWHTRate = Number(_thisOther.paytoOtherForm.get('nWHTRate').value);
                } 
                if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value != 0) {
                  nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTRate2').value);
                } 
                if (_thisOther.paytoOtherForm.get('ddlWithholdingTax2').value == 99) {
                  nWHTRate2 = Number(_thisOther.paytoOtherForm.get('nWHTOther2').value);
                }
                let arr = {
                  sInvoiceNo: _thisOther.paytoOtherForm.get('sInvoiceNo').value,
                  sVatType: _thisOther.paytoOtherForm.get('ddVatType').value,
                  nLine: _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate).length + 1,
                  sGL: arrGl[num].sGL,
                  sCostCenter: arrGl[num].sCostCenter,
                  sIO: arrGl[num].sIO,
                  sAmount: _ParseFloatToZero(arrGl[num].sAmountExcludedVAT),
                  sText: arrGl[num].sText,
                  cVenderMaster: "M",
                  cActive: arrGl[num].IsDelete == true ? 'N' : 'Y',
                  ntype: _thisOther.paytoOtherForm.get('ntype').value,
                  sVendorCode: _thisOther.paytoOtherForm.get('nVendorCode').value,
                  sVendorName: _thisOther.paytoOtherForm.get('sVendorName').value,
                  sTAXID: _thisOther.paytoOtherForm.get('sTAXID').value,
                  sVendorBranch: _thisOther.paytoOtherForm.get('sBranch').value,
                  sVendorAddress: _thisOther.paytoOtherForm.get('sAddress').value,
                  dInvoiceDate: _thisOther.datepipe.transform(_thisOther.paytoOtherForm.get('dInvoiceDate').value, 'dd/MM/yyyy'),
                  sCurrency: _thisOther.paytoOtherForm.get('ddCurrency').value,
                  nExcludeVAT: Number(_ParseFloatToZero(_thisOther.paytoOtherForm.value.nTotalAmountVat).toFixed(2)),
                  nVAT: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nVatAmount').value),
                  nIncludeVAT: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nTotalAmountInvoice').value),
                  nWHTID: nWHTID == null ? null : nWHTID,
                  nWHTID2: nWHTID2 == null ? null : nWHTID2,
                  nWHTRate: _ParseFloatToZero(nWHTRate),
                  nWHTRate2: _ParseFloatToZero(nWHTRate2),
                  nWHTVal: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTVal').value),
                  _nWHTVal: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTVal').value),
                  nWHTVal2: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTVal2').value),
                  _nWHTVal2: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTVal2').value),
                  nWHTBase: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTBase').value),
                  nWHTBase2: _ParseFloatToZero(_thisOther.paytoOtherForm.get('nWHTBase2').value),
                  nOfficeType: _thisOther.paytoOtherForm.get('cbOffice').value,
                  nInvoiceType: null,
                  sCountryID: _thisOther.paytoOtherForm.get('sCountryID').value,
                  sProvCode: _thisOther.paytoOtherForm.get('sProvCode').value,
                  sAmpCode: _thisOther.paytoOtherForm.get('sAmpCode').value,
                  sTumbonCode: _thisOther.paytoOtherForm.get('sTumbonCode').value,
                  sPostCode: _thisOther.paytoOtherForm.get('sPostCode').value,
                  sPhoneNumber: _thisOther.paytoOtherForm.get('sPhoneNumber').value,
                  sFaxNumber: _thisOther.paytoOtherForm.get('sFaxNumber').value,
                  sEmail: _thisOther.paytoOtherForm.get('sVendorEmail').value,
                  dCreateDate: null,
                  sCreateBy: "",
                  dUpdateDate: null,
                  IsDelete: false,
                }
                _thisOther.ArrInvoiceOther.push(arr);
              }
            })

            this.clearSubinvoice();
            this.CalGrand();
            this.Checkinvoice();
            //#region 2021-01-21 Log Save Invoice
            const options = { headers: { 'Content-Type': 'application/json' } };
            _thisOther.http.post<any>(_thisOther.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_thisOther.ArrInvoiceOther), options).subscribe(res => {

            })
            //#endregion
          }
          else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
            return false;
          }
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
          return false;
        }
      } else {
        //      let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT"];
        let FieldGLValid: string[];
        FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
        if (this.isUseIo) {
          FieldGLValid.push("sIO");
        }
        if (this.isUseGL) {
          FieldGLValid.push("sGL");
        }
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get('ArrGL') as FormArray;
            const control = FromArray.at(i).get(Field);             //{3}
            if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }
    }
  }
  async onBankBranchSelect(event) {
    var valueCheck = this.paytoOtherForm.hasOwnProperty('nBankKey2');
    this.paytoOtherForm.patchValue({
      ddBankKey: event.item.NAME_OF_BANK,
      nBankKey: event.item.BANK_KEY,
      ddBankKey2: this.paytoOtherForm.get('nBankKey').value === event.item.BANK_KEY && valueCheck ? this.paytoOtherForm.get('nBankKey2').value : "",
      nBankKey2: this.paytoOtherForm.get('nBankKey').value === event.item.BANK_KEY && valueCheck ? this.paytoOtherForm.get('nBankKey2').value : "",
    })
    this.paytoOtherForm.controls['ddBankKey2'].enable();

    if (event.item.NAME_OF_BANK == "N/A") {
      this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
    }
    else {
      await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + this.paytoOtherForm.get('nVendorCode').value + "/BANK/" + event.item.BANK_KEY + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
        this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
      })
    }
    if (this.DataBankBranch2.length > 0) {
      this.paytoOtherForm.patchValue({
        ddBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
        nBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
      })
    }

  }
  onBankBranchSelect2(event) {
    this.paytoOtherForm.patchValue({
      ddBankKey2: event.item.BANK_ACCOUNT,
      nBankKey2: event.item.BANK_ACCOUNT,
    })
  }
  onApprover1(value) {
    let ckNull = this.paytoOtherForm.get('ddApprover1').value;
    let ischeck = this.ArrApprover[0].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytoOtherForm.patchValue({
        sApprove1: null,
      })
    } else if (this.Approve1NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytoOtherForm.patchValue({
        sApprove1: value.item.nUserID,
      })
    } else if (this.Approve1NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoOtherForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
    if (this.Approve1NoResult == true) {
      this.paytoOtherForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
  }
  onApprover2(value) {
    let ckNull = this.paytoOtherForm.get('ddApprover2').value;
    let ischeck = this.ArrApprover[1].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytoOtherForm.patchValue({
        sApprove2: null,
      })
    } else if (this.Approve2NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytoOtherForm.patchValue({
        sApprove2: value.item.nUserID,
      })
    }
    else if (this.Approve2NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoOtherForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
    if (this.Approve2NoResult == true) {
      this.paytoOtherForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
  }

  onSubmit() {
  }

  //***********Save*****************

  async Save(mode) {
    //#region CheckValidate
    let _thisOther = this;
    let _FormGroup = this.paytoOtherForm;
    let IsValid: boolean = true;
    if (ArrFile.filter(f => f.IsDelete === false).length <= 0 && mode !== 1) {
      IsValid = false;
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid red';
    }
    let FieldValid: string[] = [];
    if (mode != 3) {
      if (mode == 1) {
        FieldValid = ["sName"];
      }
      if (mode == 2 && this.ArrInvoiceOther.filter(f => f.cActive != 'N').length == 0) {
        FieldValid = ["sName", "dDueDate", "sInvoiceNo", "sVendorName", "sTAXID", "sAddress"
          , "dInvoiceDate", "ddVatType", "nTotalAmountVat", "nVatAmount", "ddApprover2", "ddApprover1", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
        //    "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode" , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"
        if (this.isShowPO) {
          FieldValid.push('sPONo', 'sPOitem', 'sMatDoc');
        }
      }
      if (mode == 2 && this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        if (_IsNullOrEmpty(_thisOther.paytoOtherForm.get('sVendorName').value) || _IsNullOrEmpty(_thisOther.paytoOtherForm.get('sAddress').value) || _IsNullOrEmpty(_thisOther.paytoOtherForm.get('sTAXID').value)) {
          _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
          _thisOther.clicked = false;
          return false;
        }
        FieldValid = ["ddApprover2", "ddApprover1", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
        if (this.isShowPO) {
          FieldValid.push('sPONo', 'sPOitem', 'sMatDoc');
        }
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        })
      }
      let arrbank = ["ddBank", "ddBankKey"];

      if (this.forPX()) {
        arrbank.push("nBankAccountNo")
      }
      else {
        arrbank.push("ddBankKey2")
      }
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length == 0) {
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        });
        //เช็ค ArrGL
        if (IsValid) {
          if (mode == 2 && this.ArrInvoiceOther.filter(f => f.cActive != 'N').length == 0) {
            IsValid = false;
          }
          let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get('ArrGL') as FormArray;
              if (!FromArray.at(i).get(Field).valid && mode != 1) {
                IsValid = false;
                _thisOther.clicked = false;
                return false;
              }
            });
          }
        }
      }
      arrbank.forEach(function (bank) {
        if ((!_FormGroup.get(bank).valid) && _thisOther.paytoOtherForm.value.cbChequeType != 'C' && mode != 1) {
          const control = _FormGroup.get(bank);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            IsValid = false;
          }
        }
      })
      let arrinvoice = _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N')
      let arrsum = arrinvoice.map(m => _thisOther.Check2Digit(m.sAmount));
      let arrsumm = [];
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
      let GroupByinvoice = [];


      _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
        // GroupByinvoice[value.sInvoiceNo] = GroupByinvoice[value.sInvoiceNo] || [];
        let obj = {
          invoice: value.sInvoiceNo,
          InvoiceDate: value.dInvoiceDate
        }
        let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
        if (ckhave.length == 0) {
          GroupByinvoice.push(obj)
        }

      });
      GroupByinvoice.forEach(function (value, i) {
        let Get_nExcludeVAT = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
        if (Get_nExcludeVAT.length > 0) {
          arrsumm.push(_thisOther.Check2Digit(Get_nExcludeVAT[0].nExcludeVAT));
        }
      })
      var isBreak = false;
      for (var i = 0; i < GroupByinvoice.length; i++) {
        let ck = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == GroupByinvoice[i].invoice && f.dInvoiceDate == GroupByinvoice[i].InvoiceDate)[0];
        let result = await _thisOther.EditcheckDupinBase(ck.sInvoiceNo, ck.dInvoiceDate, _thisOther.paytoOtherForm.get('sRequestID').value);
        if (result == "Dup") {
          isBreak = true;
          break;
        }
      }
      if (isBreak) {
        _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, _thisOther.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
        _thisOther.clicked = false;
        return false;
      }
      let sumExclude = arrsumm.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
      if (sumExclude < 0) {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error_Negative_Value, undefined)
        _thisOther.clicked = false;
        return false;
      }
      else if (sumNumber == sumExclude) {
        //#endregion
        if (IsValid) {
          let arr = _thisOther.ArrInvoiceOther;
          for (var i = 0; i < arr.length; i++) {
            let WHTVal = arr[i].nWHTVal;
            let WHTVal2 = arr[i].nWHTVal2;
            let WHTBase = arr[i].nWHTBase;
            let WHTBase2 = arr[i].nWHTBase2;
            if (WHTVal) {
              if(typeof WHTVal === 'string'){
                arr[i].nWHTVal = _ParseFloatToZero(WHTVal);
              }
            }
            if (WHTVal2) {
              if(typeof WHTVal2 === 'string'){
                arr[i].nWHTVal2 = _ParseFloatToZero(WHTVal2);
              }
            }
            if (WHTBase) {
              if(typeof WHTBase === 'string'){
                arr[i].nWHTBase = _ParseFloatToZero(WHTBase);
              }
            }
            if (WHTBase2) {
              if(typeof WHTBase2 === 'string'){
                arr[i].nWHTBase2 = _ParseFloatToZero(WHTBase2);
              }
            }
          }
          let DataSave = {
            TRequest: {
              sRequestID: _thisOther.paytoOtherForm.get('sRequestID').value,
              //sRequestCode: this.getReqID(),
              sCompCode: _thisOther.nComcode,
              nReqType: _thisOther.paytoOtherForm.get('ntype').value + "",
              nYear: _thisOther.datepipe.transform(_thisOther.today, 'yyyy'),
              sRequestBy: _thisOther.paytoOtherForm.get('sRequestBy').value + "",
              dRequestDate: _thisOther.dToday,
              nContactID: Number(_thisOther.paytoOtherForm.get('nContactID').value),
              sContactName: _thisOther.paytoOtherForm.get('sName').value,
              dDueDate: _thisOther.datepipe.transform(_thisOther.paytoOtherForm.get('dDueDate').value, 'dd/MM/yyyy'),
              sUnitName: _thisOther.paytoOtherForm.get('sUnit').value,
              sEmail: _thisOther.paytoOtherForm.get('sEmail').value,
              sTel: _thisOther.paytoOtherForm.get('sTel').value,
              nInvoiceType: "",
              sRefAdvanceNo: "",
              IsReqUrgent: _thisOther.IsReqUrgent,
              IsAsset: _thisOther.paytoOtherForm.get('IsAsset').value,
              IsConfidential: _thisOther.paytoOtherForm.get('IsConfidential').value,
              IsPOinvoice: _thisOther.paytoOtherForm.get('IsPOinvoice').value,
              sPONo: _thisOther.paytoOtherForm.get('sPONo').value,
              sPOitem: _thisOther.paytoOtherForm.get('sPOitem').value,
              sMatDoc: _thisOther.paytoOtherForm.get('sMatDoc').value,
              sPORemark: _thisOther.paytoOtherForm.get('sPORemark').value,
              IsSSCUrgent: false,
              IsVendorGroup: false,
              sVendorCode: _thisOther.paytoOtherForm.get('nVendorCode').value,
              sCurrency: _thisOther.paytoOtherForm.get('ddCurrency').value,
              nStatusID: (mode == 1) ? 1 : 2,
              sCopyReqID: _thisOther.paytoOtherForm.get('nCopyRequest').value,
              nStep: 1,
              nFlowNo: 1,
              sPaymentType: _thisOther.paytoOtherForm.get('cbChequeType').value,
              sBankName: _thisOther.paytoOtherForm.get('ddBank').value,
              sAccountName: _thisOther.paytoOtherForm.get('sBankAccountName').value,
              sAccountNo: this.forPX() ? _thisOther.paytoOtherForm.get('nBankAccountNo').value : _thisOther.paytoOtherForm.get('ddBankKey2').value,
              sBankKey: _thisOther.paytoOtherForm.get('nBankKey').value,
              BankOther: _thisOther.paytoOtherForm.get('BankOther').value,
              nGrandTotalAmt: _ParseFloatToZero(_thisOther.paytoOtherForm.get('GtotalAmountExcluded').value),
              nGrandTotalAmtVat: _ParseFloatToZero(_thisOther.paytoOtherForm.get('GtotalVAT').value),
              nGrandTotalWithholdingTax: _ParseFloatToZero(_thisOther.paytoOtherForm.get('GtotalWithholdingTax').value),
              nGrandTotalAmtInvoice: _ParseFloatToZero(_thisOther.paytoOtherForm.get('GtotalAmountOfInvoice').value),
              sCreateBy: _thisOther.paytoOtherForm.get('sRequestBy').value + "",
              sUpdateBy: _thisOther.paytoOtherForm.get('sRequestBy').value + "",
              sDeleteBy: "",
              cSkipApprove1: _thisOther.paytoOtherForm.get('cSkipApprove1').value == 1 ? "Y" : "N",
              nApprove1: _thisOther.paytoOtherForm.get('sApprove1').value,
              cApprove1: "W",
              nApprove2: _thisOther.paytoOtherForm.get('sApprove2').value,
              cApprove2: "W",
              cSkipApprove2: "N",
              sBusinessArea: _thisOther.paytoOtherForm.get('sBusinessArea').value,
              nReqUrgentDay: _thisOther.nReqUrgentDay,
              dStartDate: _thisOther.Settodate,
              sComment: _thisOther.paytoOtherForm.get('sComment').value,
              sCommentSSC: _thisOther.paytoOtherForm.get('sCommentSSC').value,
            },
            TRequestItems: arr,
            FileUp: ArrFile,
            CommentDelete: this.sComment,
          }
          let Data = JSON.stringify(DataSave)
          let saveDaft = function () {
            _thisOther.System.BlockUI();
            _thisOther.isEditFromhome = false;
            const headers = new HttpHeaders({
              'Content-Type': 'application/json'
            });
            _thisOther.http.post(_thisOther.System.SiteName + "api/_Paytovendor/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
              if (s == "Success") {
                ArrFile = [];
                _thisOther.System.UnBlockUI();
                _thisOther.SW.SwAlert.Success(_thisOther.SW.BoxMsg.Title_Success, _thisOther.SW.BoxMsg.Desc_SaveComplete, function () { _thisOther.router.navigate(["home"]) });
              } else {
                _thisOther.SW.SwAlert.Error(_thisOther.SW.BoxMsg.Title_Error, s, undefined)
                _thisOther.System.UnBlockUI();
              }
            });
          }
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, saveDaft, function () { });
        } else {
          FieldValid.forEach(function (Field) {
            const control = _FormGroup.get(Field);
            //{3}
            if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
        if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length == 0) {
          let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get('ArrGL') as FormArray;
              const control = FromArray.at(i).get(Field);             //{3}
              if (control instanceof FormControl && mode != 1 && control.status != "DISABLED") {             //{4}
                control.markAsTouched({ onlySelf: true });
              }
            });
          }
        }
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
        _thisOther.clicked = false;
        return false;
      }
    }
    //Recall
    if (mode == 3) {
      let DataSave = {
        TRequest: {
          sRequestID: _thisOther.paytoOtherForm.value.sRequestID,
          nStatusID: 3,
        }
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        _thisOther.isEditFromhome = false;
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _thisOther.http.post(_thisOther.System.SiteName + "api/_Paytovendor/Recall", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _thisOther.SW.SwAlert.Success(_thisOther.SW.BoxMsg.Title_Success, _thisOther.SW.BoxMsg.Desc_SaveComplete, function () { _thisOther.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, SaveRecall, function () { });
    }
    _thisOther.clicked = false;
  }
  cancel() {
    let _thisOther = this;
    if (_thisOther.sComment === null || _thisOther.sComment === "") {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else {
      let DataSave = {
        TRequest: {
          sRequestID: _thisOther.paytoOtherForm.value.sRequestID,
          nStatusID: 0,
        },
        CommentDelete: this.sComment,
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _thisOther.http.post(_thisOther.System.SiteName + "api/_Paytovendor/cancel", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _thisOther.SW.SwAlert.Success(_thisOther.SW.BoxMsg.Title_Success, _thisOther.SW.BoxMsg.Desc_Success_Delete, function () { _thisOther.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, SaveRecall, function () { });
    }
  }

  //***********EditFormHome*****************

  async Edit(sReqID) {
    let _thisOther = this;
    //_thisOther.DataBankBranch = [];
    this.System.BlockUI();
    const ua = this.System.GetUserStorage();
    let Isnull = sReqID == "" ? true : false;
    if(this.isForROS) Isnull = true;
    if (ua.IsROService && Isnull) {
      this.isReject = true;
    }
    if (!Isnull) { // เช็คว่า ใบใหม่หรือใบเก่า
      _thisOther.paytoOtherForm.patchValue({ sRequestID: sReqID });
      _thisOther.isDraft = true;
      _thisOther.isPrint = true;
      _thisOther.haveComments = true;
      await this.http.get(this.System.SiteName + "api/Autocomplete/TRequest/sRequestCode/sRequestID/" + sReqID + "").toPromise().then(Data => {
        if (Data) {
          if (!isNullOrUndefined(Data[0].sRequestCode) && Data[0].sRequestCode != "") {
            _thisOther.sReqCode = Data[0].sRequestCode;
            _thisOther.haveRequestCode = true;
          }
        }
      })
      //await this.http.get(this.System.SiteName + "api/_Paytovendor/CheckReject/" + sReqID + "").toPromise().then(Data => {
      //  if (Data) {
      //    if (!isNullOrUndefined(Data[0].sComment) && Data[0].sComment != "") {
      //      _thisOther.sComment = Data[0].sComment;
      //      _thisOther.paytoOtherForm.patchValue({
      //        sComment: Data[0].sComment,
      //      })
      //    }
      //  }
      //})
      let _FormGroup = this.paytoOtherForm;
      this.ArrMaster = [];
      this.ArrMaster.push(this.ArrIO);
      this.ArrGL.clear()
      this._paytoOtherForm.ArrGL.reset();
      let data: any;
      let data2: any;
      let dbank: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + sReqID + "").toPromise().then(Data => data2 = Data)
      this.ArrTransactionHistory = data2;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
      _thisOther.ArrInvoiceOther = Array.isArray(data) ? data : [];
      if (_thisOther.ArrInvoiceOther.length === 0) {
        this.System.UnBlockUI();
        return;
      }

        await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + _thisOther.ArrInvoiceOther[0].sVendorCode).toPromise().then(res => {
          if (res) {
            this.DataBankBranch = res;
          }
          else {
            this.DataBankBranch = [];
          }
        })
        if (_thisOther.ArrInvoiceOther[0].sValue == "Y") {
          this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
        }
        if (this.DataBankBranch.length > 0) {
          if (_thisOther.ArrInvoiceOther[0].sValue == "Y" && _thisOther.ArrInvoiceOther[0].sBankKey === "N/A") {
            this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
          }
          else if (_thisOther.ArrInvoiceOther[0].sBankKey != null && _thisOther.ArrInvoiceOther[0].sBankKey != "") {
            await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + _thisOther.ArrInvoiceOther[0].sVendorCode + "/BANK/" + _thisOther.ArrInvoiceOther[0].sBankKey + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
              if (data) {
                this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
              }
            })
          }
        }

      _thisOther.Checkinvoice();
      _thisOther.ArrInvoiceOther.forEach(function (value, i) {
          _thisOther.paytoOtherForm.patchValue({
            ntype: value.ntype,
            sComment: value.sComment,
            sCommentSSC: value.sCommentSSC,
          })
          _thisOther.sComment = value.sComment;
          _thisOther.sCommentSSC = value.sCommentSSC;
          if (value.IsRoService) _thisOther.urgentDay = 8;
        
      })
      let lstArrInvoice = _thisOther.ArrInvoiceOther != null ? _thisOther.ArrInvoiceOther.filter(f => f.cActive != 'N') : [];
      if (lstArrInvoice.length > 0) { // เช็คว่า มี invoice ไหม

        if (lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) {
          let chunks = lstArrInvoice[0].dDueDate.split('/');
          this.toDay = lstArrInvoice[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(lstArrInvoice[0].dRequestDate);
          let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
          let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, dDuedate, this.holidays);

          this.message = (lstArrInvoice[0].nReqUrgentDay < this.urgentDay && this.isSubmit != true && lstArrInvoice[0].nReqUrgentDay != null) ? 'You have ' + lstArrInvoice[0].nReqUrgentDay + ' working days before due date. This is "Urgent" payment' : "";

          this.nReqUrgentDay = data[0].nReqUrgentDay;
          this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          if ((lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) && dDuedate < _thisOther.Settodate) {
            this.maxDate.setDate(this.maxDate.getDate() + 1)
            this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
            let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
            this.olddate = "Old Due Date " + lstArrInvoice[0].dDueDate;
            this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
            this.nReqUrgentDay = check_date;
            this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          }
          await _thisOther.http.get(_thisOther.System.SiteName + "api/_paytovendor/GetRequest/" + lstArrInvoice[0].sCopyReqID + "").toPromise().then((data: any) => {
            if (data != null) {
              let Data = data.filter(f => f.cActive != 'N');
              _thisOther.paytoOtherForm.patchValue({
                sCopyRequest: Data[0].sRequestCode,
              })
            }
          })
          let ddBankKey: any = [];
          let ddBankKey2: any = [];
          if (!_IsNullOrEmpty(lstArrInvoice[0].sBankKey)) {
            //โจ้เปลี่ยน 29/03/2021 ไม่งั้นถ้า .Then แล้วไม่มีข้อมูลระบบตาย
            //ddBankKey = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + lstArrInvoice[0].sBankKey + "").toPromise().then(data => data[0]);
            let GetDT = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + lstArrInvoice[0].sBankKey + "").toPromise();
            if (lstArrInvoice[0].sBankKey === "N/A") {
              GetDT = [{ NAME_OF_BANK: "N/A" }]
            }
            if (GetDT) {
              ddBankKey = GetDT;
            }
            let GetDT2 = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/BANK_ACCOUNT/VENDOR_CODE/" + lstArrInvoice[0].sVendorCode + "/BANK_ACCOUNT/" + lstArrInvoice[0].sAccountNo).toPromise();
            if (GetDT2) {
              ddBankKey2 = GetDT2;
            }
          } else {
            ddBankKey = [];
            ddBankKey2 = [];
          }
          let isOntime: any;
          if (lstArrInvoice[0].sVendorCode != null) {

            if (lstArrInvoice[0].IsVendorOneTime) {
              isOntime = true;
            } else {
              isOntime = false;
            }
          }
          this.onTypeSelect(lstArrInvoice[0].sVendorCode, isOntime);
          _thisOther.isEditFromhome = true;
          const httpOptions_Amphur = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            }),
            params: new HttpParams()
              .set("sProvCode", lstArrInvoice[0].sProvCode)
          };
          await _thisOther.http.get<any>(_thisOther.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
            if (res) {
              _thisOther._ArrAmphur = res;
            }
          });
          const httpOptions_Tumbon = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            }),
            params: new HttpParams()
              .set("sAmpCode", lstArrInvoice[0].sAmpCode)
          };
          await _thisOther.http.get<any>(_thisOther.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
            if (res) {
              _thisOther._ArrTumbon = res;
            }
          });
          let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstArrInvoice[0].sAmpCode)[0];
          let Country = this._ArrCountry.filter(f => f.sCountryID == lstArrInvoice[0].sCountryID)[0];
          let prov = this._ArrProvince.filter(f => f.sProvCode == lstArrInvoice[0].sProvCode)[0];
          let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstArrInvoice[0].sTumbonCode)[0];
          let value = { value: lstArrInvoice[0].sBankName };
          let event = { target: value }
          this.Onbankother(event);
          this.hBranch = lstArrInvoice[0].nOfficeType == 2 ? false : true;

          if (this.hBranch == false) {
            this.paytoOtherForm.controls['sBranch'].enable();
            this.paytoOtherForm.patchValue({
              sBranch: lstArrInvoice[0].sVendorBranch,
              cbOffice: lstArrInvoice[0].nOfficeType,
            })
            if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
              this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                invoice.cbOffice = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
                invoice.sVendorBranch = lstArrInvoice[0].sVendorBranch;
              })
            }
          } else {
            this.paytoOtherForm.controls['sBranch'].disable();
            this.paytoOtherForm.patchValue({
              sBranch: "",
              cbOffice: lstArrInvoice[0].nOfficeType,
            })
            if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
              this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                invoice.cbOffice = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
                invoice.sVendorBranch = "";
              })
            }
          }

          _thisOther.ArrInvoiceOther.forEach(function (value, i) {
            if (value.sPaymentType == "C") {
              _thisOther.paytoOtherForm.controls['ddBank'].disable();
              _thisOther.paytoOtherForm.patchValue({ sBankAccountName: "" });
            } else {
              _thisOther.messagebank = "Please include passbook and ID Card together with original set of document";
            }
            _thisOther.Currencys = value.sCurrency;
            _thisOther.chackbank(value.sPaymentType);
            _thisOther.IsVendorOneTime = value.IsVendorOneTime;
            _thisOther.isDraft = (value.nStatusID == 1 || value.nStatusID == 3 || value.nStatusID == 5 || value.nStatusID == 7 || value.nStatusID == 10 ? true : false);
            _thisOther.isSubmit = (value.nStatusID == 2 ? true : false);
            _thisOther.isNew = true;
            _thisOther.isPrint = true;
            _thisOther.isThai = true;
            value.IsDelete = value.cActive == 'N' ? true : false;
            if (value.cSkipApprove1 == "Y") {
              _thisOther.paytoOtherForm.get('ddApprover1').disable()
            } else {
              _thisOther.paytoOtherForm.get('ddApprover1').enable();
            }

            _thisOther.messageAsset = value.IsAsset == true ? "Please include Asset Creation Form together with original set of document" : "";



            _thisOther.paytoOtherForm.patchValue({
              nContactID: value.nContactID + "",
              sName: value.sName,
              sEmail: value.sEmail,
              sUnit: value.sUnit,
              sTel: value.sTel,
              ntype: value.ntype,
              dDueDate: new Date(_thisOther.convertTodate(value.dDueDate)),
              cbOffice: isNullOrUndefined(value.nOfficeType) == true ? 1 : value.nOfficeType,
              IsAsset: value.IsAsset,
              IsConfidential: value.IsConfidential,
              IsPOinvoice: value.IsPOinvoice,
              sPONo: value.sPONo,
              sPOitem: value.sPOitem,
              sMatDoc: value.sMatDoc,
              sPORemark: value.sPORemark,
              nCopyRequest: value.sCopyReqID,
              nVendorCode: value.sVendorCode,
              sVendorName: value.sVendorName,
              sTAXID: value.sTAXID,
              sBranch: value.sVendorBranch,
              sAddress: value.sVendorAddress,
              sCountryID: value.sCountryID,
              txtCountryID: isNullOrUndefined(Country) == true ? "" : Country.sCountryName,
              sProvCode: value.sProvCode,
              // sProvName: isNullOrUndefined(prov) == true ? "" : prov.sProvname,
              sProvName: value.sProvName,
              sAmpCode: value.sAmpCode,
              //sAmpName: isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
              sAmpName: value.sAmpName,
              sTumbonCode: value.sTumbonCode,
              //sTumbonName: isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName,
              sTumbonName: value.sTumbonName,
              sPostCode: value.sPostCode,
              sPhoneNumber: value.sPhoneNumber,
              sFaxNumber: value.sFaxNumber,
              sVendorEmail: value.sVendorEmail,
              sBankAccountName: value.sPaymentType == "C" ? "" : value.sAccountName,
              cbChequeType: value.sPaymentType,
              ddBank: value.sPaymentType == "C" ? "" : value.sBankName,
              nBankAccountNo: value.sAccountNo,
              ddBankKey: (ddBankKey.length > 0) ? ddBankKey[0].NAME_OF_BANK : _thisOther.ArrInvoiceOther[0].sValue == "Y" && _thisOther.ArrInvoiceOther[0].sBankKey == "N/A" ? "N/A" : "",
              ddBankKey2: _thisOther.ArrInvoiceOther[0].sValue == "Y" && _thisOther.ArrInvoiceOther[0].sAccountNo == "N/A" && ddBankKey.length > 0 ? "N/A" : _thisOther.ArrInvoiceOther[0].sAccountNo,
              nBankKey: (ddBankKey.length > 0) ? value.sBankKey : null,
              sRequestID: value.sRequestID,
              BankOther: value.sBankOther,
              ddApprover1: value.sUserApprove1,
              ddApprover2: value.sUserApprove2,
              sApprove1: value.nApprove1 == null ? null : value.nApprove1,
              sApprove2: value.nApprove2 == null ? null : value.nApprove2,
              cSkipApprove1: value.cSkipApprove1 == "Y" ? true : false,
              GtotalAmountExcluded: _ParseFloatToZero(value.nGrandTotalAmt),
              GtotalVAT: _ParseFloatToZero(value.nGrandTotalAmtVat),
              GtotalWithholdingTax: _ParseFloatToZero(value.nGrandTotalWithholdingTax),
              GtotalAmountOfInvoice: _ParseFloatToZero(value.nGrandTotalAmtInvoice),
              ddCurrency: value.sCurrency,
              sComment: value.sComment,
              sCommentSSC: value.sCommentSSC,
            })

            _thisOther.sComment = value.sComment;
            _thisOther.sCommentSSC = value.sCommentSSC;
          if (value.IsRoService) _thisOther.urgentDay = 8;

          })

          this.isShowPO = this.paytoOtherForm.get('IsPOinvoice').value;

          if (this.isShowPO) {
            this.paytoOtherForm.controls.sPONo.setValidators([Validators.required]);

            this.paytoOtherForm.controls.sPOitem.setValidators([Validators.required]);

            this.paytoOtherForm.controls.sMatDoc.setValidators([Validators.required]);
          }
        }
        _thisOther.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        }))
        this.checkUseIo();
        this.checkUseGL();
        this.System.UnBlockUI();
      } else {
        this.ArrMaster = [];
        this.ArrMaster.push(this.ArrIO);
        this.ArrGL.clear();
        this.Currencys = "THB";
        _thisOther.paytoOtherForm.patchValue({
          GtotalVAT: 0,
          GtotalAmountExcluded: 0,
          GtotalAmountOfInvoice: 0,
          GtotalWithholdingTax: 0,
        });
        this._paytoOtherForm.ArrGL.reset();
        _thisOther.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        }))
        _thisOther.isNew = true;
        _thisOther.ArrInvoiceOther = [];
        this.checkUseIo();
        this.checkUseGL();
        let data: any;
        let dbank: any;
        await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequestNoItem/" + sReqID + "").toPromise().then(Data => data = Data)
        if (data != null) {
          let chunks = data[0].dDueDate.split('/');
          this.toDay = data[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(data[0].dRequestDate);
          let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
          //       let check_date = this.BusinessDay.SetDueDate(dDuedate, this.holidays);
          let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, dDuedate, this.holidays);
          this.message = (check_date < this.urgentDay && this.isSubmit != true && data[0].nReqUrgentDay != null) ? 'You have ' + data[0].nReqUrgentDay + ' working days before due date. This is "Urgent" payment' : "";
          this.nReqUrgentDay = data[0].nReqUrgentDay;
          this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          if ((data[0].nStatusID == 1 || data[0].nStatusID == 3 || data[0].nStatusID == 5 || data[0].nStatusID == 7 || data[0].nStatusID == 10) && dDuedate < _thisOther.Settodate) {
            this.maxDate.setDate(this.maxDate.getDate() + 1)
            this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
            let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
            this.olddate = "Old Due Date " + data[0].dDueDate;
            this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
            this.nReqUrgentDay = check_date;
            this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          }
          if (data[0].sPaymentType == "T") {
            _thisOther.messagebank = "Please include passbook and ID Card together with original set of document";
          } else {
            _thisOther.messagebank = "";
          }
          let ddBankKey: any;
          let ddBankKey2: any;
          if (!_IsNullOrEmpty(data[0].sBankKey)) {
            //ddBankKey = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + data[0].sBankKey + "").toPromise().then(data => data[0]);
            //โจ้เปลี่ยน 29/03/2021 ไม่งั้นถ้า .Then แล้วไม่มีข้อมูลระบบตาย
            let GetDT = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + data[0].sBankKey + "").toPromise();
            if (GetDT) {
              ddBankKey = GetDT;
            }
            let GetDT2 = await _thisOther.http.get(_thisOther.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/BANK_ACCOUNT/VENDOR_CODE/" + lstArrInvoice[0].sVendorCode + "/BANK_ACCOUNT/" + lstArrInvoice[0].sAccountNo).toPromise();
            if (GetDT2) {
              ddBankKey2 = GetDT2;
            }
          } else {
            ddBankKey = null;
            ddBankKey2 = null;
          }
          if (data[0].cSkipApprove1 == "Y") {
            _thisOther.paytoOtherForm.get('ddApprover1').disable()
          } else {
            _thisOther.paytoOtherForm.get('ddApprover1').enable();
          }
          _thisOther.paytoOtherForm.patchValue({
            dDueDate: dDuedate,
            nContactID: data[0].nContactID + "",
            sName: data[0].sName,
            sEmail: data[0].sEmail,
            sUnit: data[0].sUnit,
            sTel: data[0].sTel,
            ntype: data[0].ntype,

            sBankAccountName: data[0].sPaymentType == "C" ? "" : data[0].sAccountName,
            cbChequeType: data[0].sPaymentType,
            ddBank: data[0].sPaymentType == "C" ? "" : data[0].sBankName,
            nBankAccountNo: data[0].sAccountNo,
            ddBankKey: (ddBankKey != null) ? ddBankKey.NAME_OF_BANK : data[0].sValue == "Y" && data[0].sBankKey == "N/A" ? "N/A" : "",
            ddBankKey2: (ddBankKey2 != null) ? ddBankKey2.BANK_ACCOUNT : data[0].sValue == "Y" && data[0].sAccountNo == "N/A" ? "N/A" : "",
            nBankKey: data[0].sBankKey,
            sRequestID: data[0].sRequestID,
            BankOther: data[0].sBankOther,
            ddApprover1: data[0].sUserApprove1,
            ddApprover2: data[0].sUserApprove2,
            sApprove1: data[0].nApprove1 == null ? null : data[0].nApprove1,
            sApprove2: data[0].nApprove2 == null ? null : data[0].nApprove2,
            cSkipApprove1: data[0].cSkipApprove1 == "Y" ? true : false,

          });
        }
        this.System.UnBlockUI();
      }
    } else {
      this.messagebank = "Please include passbook and ID Card together with original set of document";
      this.Currencys = "THB";
      if (!this.isNewRequest) {
        let data: any;
        await _thisOther.http.get(_thisOther.System.SiteName + "api/ROService/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
        if(data != null){
          _thisOther.paytoOtherForm.patchValue({
            sRequestID: data[0].sRequestID,
            ntype: data[0].nReqType.toString(),
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          _thisOther.sComment = data[0].sComment;
          _thisOther.sCommentSSC = data[0].sRemarkSSC;
          _thisOther.onTypeSelect(data[0].nReqType.toString(), false);
          _thisOther.onUserSelect(data[0].sFullName);
        }
      }
     
      _thisOther.paytoOtherForm.patchValue({
        GtotalVAT: 0,
        GtotalAmountExcluded: 0,
        GtotalAmountOfInvoice: 0,
        GtotalWithholdingTax: 0,
      });
    }
    if (!this.isNewRequest) {
      let file: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "").toPromise().then(Data => file = Data);
      if (file) {
        let arrdata = [];
        if (file.length != 0) {
          file.forEach(f => arrdata.push({
            nID: f.nFileOrder,
            sPath: f.sPathFile,
            sSystemFileName: f.sSystemFileName,
            sFileName: f.sFileName,
            sSize: +f.sFileSize,
          }))
          SetData('dvFile', arrdata)
        }
      }
    }
    
    //Check Permission
    let ObjData = {
      sRequestID: sReqID,
      nMenuID: 10
    }
    let isio = await this.System.GetCompanyUSEIO(ObjData);
    if (isio != null) {
      _thisOther.isUseIo = isio;
      _thisOther.IsNotFill_IO = isio;
      _thisOther.checkUseIo();
    }
    let isGL = await this.System.GetCompanyUSEGL(ObjData);
    if (isGL != null) {
      _thisOther.isUseGL = isGL;
      _thisOther.IsNotFill_GL = isGL;
      _thisOther.checkUseGL();
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (!this.ResultPermission) {
      this.paytoOtherForm.disable();
      this.paytoOtherForm.get('GtotalVAT').enable();
      this.paytoOtherForm.get('GtotalAmountExcluded').enable();
      this.paytoOtherForm.get('GtotalAmountOfInvoice').enable();
      this.paytoOtherForm.get('GtotalWithholdingTax').enable();
      this.paytoOtherForm.get('sCompName').enable();
    }

    this.System.UnBlockUI();
  }

  //*****************************************
  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.paytoOtherForm.get('ArrGL') as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          let stG = this.ArrGL.at(_inx).get('sGL').value;
          let ischeckG = this.sArrGL.filter(f => f.GL_ACCOUNT_NO == stG || f.name == stG || f.SHORT_TEXT == stG)[0];
          if (isNullOrUndefined(ischeckG)) {
            Pass = false;
          }
          break;
        case "C":
          let stC = this.ArrGL.at(_inx).get('sCostCenter').value;
          let ischeckC = this.ArrCostCenter.filter(f => f.COST_CENTER == stC || f.name == stC || f.DESCRIPTION == stC)[0];
          if (isNullOrUndefined(ischeckC)) {
            Pass = false;
          }
          break;
        case "I":
          let stI = this.ArrGL.at(_inx).get('sIO').value;
          let ischeckI = this.ArrMaster[_inx].filter(f => f.ORDER_NUMBER == stI || f.name == stI || f.DESCRIPTION == stI)[0];
          if (isNullOrUndefined(ischeckI)) {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      this.OnSelectGCI(event, _inx, _sType)
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
    }
  }
  OnSelectGCI(event, _inx, _sType) {
    let _thisOther = this;
    let FromArray = this.paytoOtherForm.get('ArrGL') as FormArray;
    let sGL = FromArray.at(_inx).get("sGL").value;
    let sCostCenter = FromArray.at(_inx).get("sCostCenter").value;
    let sIO = (FromArray.at(_inx).get("sIO").value != null) ? FromArray.at(_inx).get("sIO").value : ""; //แก้ไขกรณี company ไม่มี IO

    let SP_GL = sGL.split('-');
    let SP_CCTR = sCostCenter.split('-');
    let SP_IO = sIO.split('-');

    let SE_GL = SP_GL.length > 1 ? (SP_GL[0] + "").trim() : sGL;
    let SE_CCTR = SP_CCTR.length > 1 ? (SP_CCTR[0] + "").trim() : sCostCenter;
    let SE_IO = SP_IO.length > 1 ? (SP_IO[0] + "").trim() : sIO;

    let _CHK = this.OnChange_CheckDuplicateGCI(SE_GL, SE_CCTR, SE_IO, _inx);
    if (false) {
    //if (!_CHK.IsPass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close() });
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
          break;
        case "C":
          this.ArrMaster[_inx] = this.ArrIO;
          FromArray.at(_inx).patchValue({ sCostCenter: event.item.COST_CENTER });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
          break;
      }
    }
  }

  AddGL() {
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl('')
    }));
    this.checkUseIo()
  }
  DeleteGL(sInvoiceNo, row) {

    let _thisOther = this;
    //let isnull = !isNullOrUndefined(sInvoiceNo) ? sInvoiceNo : "";
    //if (isnull != "") {
    //    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
    //      _thisOther.ArrGL.at(row).patchValue({ IsDelete: true });
    //      //let data = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == sInvoiceNo)[row];
    //      //data.IsDelete = true;
    //      //  let FromArray = _thisOther.paytoOtherForm.get('ArrGL') as FormArray;
    //      let FieldGLValid: string[] = ['sGL', 'sCostCenter', 'sIO', 'sAmountExcludedVAT'];
    //      for (let i = 0; i < FieldGLValid.length; i++) {
    //        _thisOther.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
    //        _thisOther.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
    //        _thisOther.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
    //      }
    //      _thisOther.Checkinvoice();
    //    }, function () { });
    //} else {

    //  this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
    //    _thisOther.ArrGL.at(row).patchValue({ IsDelete: true });
    //    //  let FromArray = _thisOther.paytoOtherForm.get('ArrGL') as FormArray;
    //    let FieldGLValid: string[] = ['sGL', 'sCostCenter', 'sIO', 'sAmountExcludedVAT'];
    //    for (let i = 0; i < FieldGLValid.length; i++) {

    //      _thisOther.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
    //      _thisOther.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
    //      _thisOther.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
    //    }
    //    _thisOther.Checkinvoice();
    //  }, function () { });
    //}

    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
      _thisOther.ArrGL.at(row).patchValue({ IsDelete: true });
      let isnull = !isNullOrUndefined(sInvoiceNo) ? sInvoiceNo : "";
      if (isnull == "") {
        _thisOther.ArrGL.removeAt(row);
      } else {
        let data = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == sInvoiceNo)[row];
        if (data) {
          data.IsDelete = true;
        }
        //  let FromArray = _thisOther.paytoOtherForm.get('ArrGL') as FormArray;
        let FieldGLValid: string[] = ['sGL', 'sCostCenter', 'sIO', 'sAmountExcludedVAT', 'sText'];
        for (let i = 0; i < FieldGLValid.length; i++) {

          _thisOther.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
          _thisOther.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
          _thisOther.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
        }
      }
      // _thisOther.Checkinvoice();
    }, function () { });
  }
  OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = this.ArrGL.value[i].IsDelete;
        let _sGL = this.ArrGL.value[i].sGL;
        let _sCostCenter = this.ArrGL.value[i].sCostCenter;
        let _sIO = this.ArrGL.value[i].sIO;
        if (!Isdelete) {
          if (this.IsNotFill_IO && this.IsNotFill_GL) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO && IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ CostCenter
              if (sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!_IsNullOrEmpty(sGL) && !_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_GL) {//IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!_IsNullOrEmpty(sIO) && !_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ IO,CostCenter
              if (sIO == _sIO && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            if (sGL == _sGL && sCostCenter == _sCostCenter && sIO == _sIO) { //เช็คแค่ GL,CostCenter , IO
              Result.IsPass = false;
              Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
              return Result;
            }
          }
        }
      }
    }

    //Case 2 เช็คจาก Array GL ที่กรอก
    //if (Result.IsPass) {
    //  let DupInvoice = this._ArrVendorInvoice.filter(w =>
    //    w.sGL == sGL
    //    && w.sCostCenter == sCostCenter
    //    && (sIO == null ? true : (w.sIO != sIO))
    //    && w.IsDelete == false
    //    && (this.InvoiceEdit == null ? true : (w.nRowVendor != this.InvoiceEdit))//ตรวจสอบว่า InvoiceEdit มีค่าไหมถ้าไม่มีระบบจะไม่สนใจเงื่อนไขนี้ แต่ถ้ามีจะหาตัวที่ไม่เท่ากับ nRowVendor ที่กด Edit มา
    //  );
    //  if (DupInvoice.length > 0) {
    //    Result.IsPass = false;
    //    Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;;
    //  }
    //}


    return Result;
  }
  CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sGL", sGL)
        .set("sCostCenter", sCostCenter)
        .set("sIO", sIO)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/CheckDuplicateGCI", httpOptions).subscribe(res => {
      if (res) {
        if (res.length > 0) {
          Result.IsPass = false;
          Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
        }
        else {
          Result.IsPass = true;
        }
      }
      else {
        Result.IsPass = true;
      }
    });
    return Result;
  }
  hidBranch() {
    let _thisOther = this;
    this.hBranch = this.paytoOtherForm.value.cbOffice == 2 ? false : true;
    if (this.hBranch == false) {
      var code = this.paytoOtherForm.get('sBranch').value;
      if (code === '') code = '00000'
      this.paytoOtherForm.controls['sBranch'].enable();
      this.paytoOtherForm.patchValue({ sBranch: code })
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
          invoice.nOfficeType = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
          invoice.sVendorBranch = code;
        })
      }
    } else {
      this.paytoOtherForm.controls['sBranch'].disable();
      this.paytoOtherForm.patchValue({ sBranch: "" })
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
          invoice.nOfficeType = _thisOther.paytoOtherForm.value.cbOffice == 1 ? 1 : _thisOther.paytoOtherForm.value.cbOffice;
          invoice.sVendorBranch = "";
        })
      }
    }
  }
  hidBankDetail() {
    let _thisOther = this;
    this.hBank = this.paytoOtherForm.value.cbChequeType == 'C' ? true : false;
    if (this.hBank == false) {
      this.paytoOtherForm.controls.nBankAccountNo.clearValidators();
      this.paytoOtherForm.controls.nBankAccountNo.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.nBankAccountNo.setValidators([Validators.required]);
      this.paytoOtherForm.controls.nBankAccountNo.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBankKey.clearValidators();
      this.paytoOtherForm.controls.ddBankKey.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBankKey.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBankKey.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBankKey2.clearValidators();
      this.paytoOtherForm.controls.ddBankKey2.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBankKey2.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBankKey2.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBank.clearValidators();
      this.paytoOtherForm.controls.ddBank.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBank.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBank.updateValueAndValidity();
      this.paytoOtherForm.controls['sBankAccountName'].enable();
      // this.paytoOtherForm.controls['nBankAccountNo'].enable();
      this.paytoOtherForm.controls['nBankKey'].enable();
      this.paytoOtherForm.controls['ddBankKey'].enable();
      // this.paytoOtherForm.controls['ddBankKey2'].enable();
      this.paytoOtherForm.controls['ddBank'].enable();
      this.paytoOtherForm.patchValue({ sBankAccountName: _thisOther.paytoOtherForm.get('sVendorName').value })
      this.paytoOtherForm.patchValue({ cbChequeType: 'T' });
      _thisOther.messagebank = "Please include passbook and ID Card together with original set of document";

    } else {
      let bankvalidate = ["nBankAccountNo", "ddBank", "ddBankKey", "ddBankKey2"];
      bankvalidate.forEach(function (form) {
        _thisOther.paytoOtherForm.controls[form].clearValidators();
        _thisOther.paytoOtherForm.controls[form].markAsUntouched({ onlySelf: true });
        _thisOther.paytoOtherForm.controls[form].setValidators([]);
        _thisOther.paytoOtherForm.controls[form].updateValueAndValidity();
      })
      this.paytoOtherForm.controls['sBankAccountName'].disable();
      this.paytoOtherForm.controls['nBankAccountNo'].disable();
      this.paytoOtherForm.controls['nBankKey'].disable();
      this.DataBankBranch2 = [];
      this.paytoOtherForm.controls['ddBankKey'].disable();
      this.paytoOtherForm.controls['ddBankKey2'].disable();
      this.paytoOtherForm.controls['ddBank'].disable();
      this.paytoOtherForm.patchValue({ ddBank: "", });
      this.paytoOtherForm.controls["BankOther"].clearValidators();
      this.paytoOtherForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls["BankOther"].setValidators([]);
      this.paytoOtherForm.controls["BankOther"].setErrors(null);
      this.paytoOtherForm.controls["BankOther"].updateValueAndValidity();
      this.paytoOtherForm.controls["BankOther"].disable()
      this.paytoOtherForm.patchValue({
        sBankAccountName: "",
        ddBankKey: "",
        ddBankKey2: "",
        nBankKey: "",
        BankOther: "",
        nBankAccountNo: "",
      })
      this.paytoOtherForm.patchValue({ cbChequeType: 'C' });
      _thisOther.messagebank = "";
    }


  }
  OnSkipApprove1() {
    let _thisOther = this;
    if (_thisOther.paytoOtherForm.value["cSkipApprove1"]) {
      _thisOther.paytoOtherForm.patchValue({ sApprove1: null });
      _thisOther.paytoOtherForm.get('ddApprover1').reset();
      _thisOther.paytoOtherForm.get('ddApprover1').disable();
    }
    else {
      let name1 = _thisOther.DataApprover.filter(f => f.nUserID == _thisOther.GetApprover.name1ID)[0];
      let nUserId = _thisOther.DataApprover.filter(f => f.nUserID == _thisOther.GetApprover.name1ID)[0];
      this.paytoOtherForm.patchValue({
        ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
        sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
      })
      this.paytoOtherForm.get('ddApprover1').enable();
    }
  }
  Export() {
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", this.paytoOtherForm.get("nContactID").value),

    };
    // link.href = this.System.SiteName + "api/ExportPDF/export/" + this.sReqID + "/" + this.paytoOtherForm.get("nContactID").value;
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
  Back() {
    this.router.navigate(['/home'])
  }
  OnAsset() {
    if (this.paytoOtherForm.get('IsAsset').value == true) {
      this.messageAsset = "Please include Asset Creation Form together with original set of document";
    } else {
      this.messageAsset = "";
    }
  }
  OnConfidential() {
    let _thisOther = this;
    if (this.paytoOtherForm.get('IsConfidential').value == true) {
      let cancelConfidential = function () {
        _thisOther.paytoOtherForm.get('IsConfidential').setValue(false);
      }
      this.SW.SwAlert.infoConfidential(this.SW.BoxMsg.Title_Notice, this.SW.BoxMsg.Desc_Confidential_Submit, function () { }, cancelConfidential);
    }
  }
  OnPOInvoice() {
    this.isShowPO = this.paytoOtherForm.get('IsPOinvoice').value;

    this.paytoOtherForm.patchValue({
      sPONo: null,
      sPOitem: this.isShowPO ? '1' : null,
      sMatDoc: null,
      sPORemark: null
    });

    this.paytoOtherForm.controls.sPONo.setValidators(this.isShowPO ? [Validators.required] : null);
    this.paytoOtherForm.controls.sPONo.markAsUntouched({ onlySelf: true });
    this.paytoOtherForm.controls.sPONo.updateValueAndValidity();

    this.paytoOtherForm.controls.sPOitem.setValidators(this.isShowPO ? [Validators.required] : null);
    this.paytoOtherForm.controls.sPOitem.markAsUntouched({ onlySelf: true });
    this.paytoOtherForm.controls.sPOitem.updateValueAndValidity();

    this.paytoOtherForm.controls.sMatDoc.setValidators(this.isShowPO ? [Validators.required] : null);
    this.paytoOtherForm.controls.sMatDoc.markAsUntouched({ onlySelf: true });
    this.paytoOtherForm.controls.sMatDoc.updateValueAndValidity();

  }
  chackbank(PaymentType) {
    let _thisOther = this;
    this.hBank = PaymentType == 'C' ? true : false;
    if (this.hBank == false) {
      this.paytoOtherForm.controls.nBankAccountNo.clearValidators();
      this.paytoOtherForm.controls.nBankAccountNo.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.nBankAccountNo.setValidators([Validators.required]);
      this.paytoOtherForm.controls.nBankAccountNo.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBankKey.clearValidators();
      this.paytoOtherForm.controls.ddBankKey.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBankKey.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBankKey.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBankKey2.clearValidators();
      this.paytoOtherForm.controls.ddBankKey2.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBankKey2.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBankKey2.updateValueAndValidity();
      this.paytoOtherForm.controls.ddBank.clearValidators();
      this.paytoOtherForm.controls.ddBank.markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls.ddBank.setValidators([Validators.required]);
      this.paytoOtherForm.controls.ddBank.updateValueAndValidity();
      this.paytoOtherForm.controls['sBankAccountName'].enable();
      this.paytoOtherForm.controls['nBankAccountNo'].enable();
      this.paytoOtherForm.controls['nBankKey'].enable();
      this.paytoOtherForm.controls['ddBankKey2'].enable();
      this.paytoOtherForm.controls['ddBank'].enable();

    } else {
      let bankvalidate = ["nBankAccountNo", "ddBank", "ddBankKey", "ddBankKey2"];
      bankvalidate.forEach(function (form) {
        _thisOther.paytoOtherForm.controls[form].clearValidators();
        _thisOther.paytoOtherForm.controls[form].markAsUntouched({ onlySelf: true });
        _thisOther.paytoOtherForm.controls[form].setValidators([]);
        _thisOther.paytoOtherForm.controls[form].updateValueAndValidity();
      })
      this.paytoOtherForm.controls['sBankAccountName'].disable();
      this.paytoOtherForm.controls['nBankAccountNo'].disable();
      this.paytoOtherForm.controls['nBankKey'].disable();
      this.DataBankBranch2 = [];
      this.paytoOtherForm.controls['ddBankKey'].disable();
      this.paytoOtherForm.controls['ddBankKey2'].disable();
      this.paytoOtherForm.controls['ddBank'].disable();

      this.paytoOtherForm.controls["BankOther"].clearValidators();
      this.paytoOtherForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoOtherForm.controls["BankOther"].setValidators([]);
      this.paytoOtherForm.controls["BankOther"].setErrors(null);
      this.paytoOtherForm.controls["BankOther"].updateValueAndValidity();
      this.paytoOtherForm.controls["BankOther"].disable();
    }
  }
  //#region "SetForm"
  SetForm() {
    let ua = this.System.GetUserStorage()
    this.paytoOtherForm = this.formBuilder.group({
      sRequestID: [null],
      sRequestBy: [ua.nUserID],
      nContactID: [ua.nUserID],
      sName: [ua.sFullName, Validators.required],

      sEmail: [ua.sEmail, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")],
      sUnit: [ua.sUnitName],
      sTel: [ua.sTel],
      dToday: [this.dToday],
      sCompCode: [ua.sCompCode],
      sCompName: [ua.sCompName],
      sBusinessArea: [null],

      ntype: ["50"],
      dDueDate: [null, Validators.required],
      sCopyRequest: [null],
      nCopyRequest: [null],
      nVendorCode: [null, Validators.required],
      sTAXID: [null, Validators.required],
      sVendorName: [null, Validators.required],
      cbOffice: [1],
      sBranch: [null],
      sAddress: [null, Validators.required],

      sCountryID: "",
      txtCountryID: "",
      sProvCode: "",
      sProvName: "",
      sAmpCode: "",
      sAmpName: "",
      sTumbonCode: "",
      sTumbonName: "",
      sPostCode: "",
      sPhoneNumber: "",
      sFaxNumber: "",
      sVendorEmail: "",
      sAddressOneTime: "",

      sInvoiceNo: [null, Validators.required],
      dInvoiceDate: [new Date(), Validators.required],
      nTotalAmount: [null],
      ddCurrency: ["THB"],
      nVat: [null,],
      ddVatType: ["-1"],
      nVatAmount: [null, Validators.required],
      nTotalAmountInvoice: [null],
      nTotalAmountVat: [null, Validators.required],
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTRate: [null],
      nWHTRate2: [null],
      nWHTOther: [null],
      nWHTOther2: [null],
      nWHTVal: [null],
      _nWHTVal: [null],
      nWHTVal2: [null],
      _nWHTVal2: [null],
      nWHTBase: [null],
      nWHTBase2: [null],
      sComment: [null],
      sCommentSSC: [null],

      ArrGL: new FormArray([
        new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(false),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        })
      ]),

      IsAsset: [false],
      IsConfidential: [false],
      IsPOinvoice: [false],
      cbChequeType: ['T'],
      ddBank: ["", Validators.required],
      BankOther: ua.sCompCode == 396 ? ["", Validators.required] : [null],
      sBankAccountName: [null],
      nBankAccountNo: [null, Validators.required],
      nBankKey: [null],
      ddBankKey: [null, Validators.required],
      ddBankKey2: [null, Validators.required],
      GtotalAmountOfInvoice: [null],
      GtotalAmountExcluded: [null],
      GtotalWithholdingTax: [null],
      GtotalVAT: [null],

      ddApprover1: [null, Validators.required],
      sApprove1: [null],
      sApprove2: [null],
      ddApprover2: [null, Validators.required],
      cSkipApprove1: [null],
      sPONo: [null, Validators.required],
      sPOitem: ["1", Validators.required],
      sMatDoc: [null, Validators.required],
      sPORemark: [null, Validators.required],
    });
  }
  
  CheckPattern(event) {
    const charCode = event.key;
    if (charCode != "Backspace") {
      var regExp = new RegExp('[0-9]', 'g');
      if (regExp.test(charCode)) {
        return true;
      } else {
        return false;
      }
    }
  }
  getReqID() {
    let comcode = this.nComcode;
    let width = comcode.toString().length;
    if (width > 0) {
      comcode = new Array(width == 3 ? 0 : 3).join('0') + comcode;
    }
    let dToday = this.datepipe.transform(this.today, 'yyMMdd')
    let type = this.paytoOtherForm.value.ntype;
    let ReqID: string = comcode + dToday + type;
    return ReqID;
  }

  //#region Validate
  isFieldValid(_Field: string) {
    return !this.paytoOtherForm.get(_Field).valid && this.paytoOtherForm.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.paytoOtherForm.get('ArrGL') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbGl(_Field, _inx),
      'has-feedback': this.isFieldValidTbGl(_Field, _inx)
    };
  }
  //#endregion
  async checkDupinBase(Invoice, InvoiceDate) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/CheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }

  async EditcheckDupinBase(Invoice, InvoiceDate, sReqid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sReqid: sReqid, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/EditCheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }
  CalGrand() {
    let _thisOther = this;
    this.Currencys = this.paytoOtherForm.get('ddCurrency').value;
    let arrGtotalAmountOfInvoice = _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _thisOther.Check2Digit(m.sAmount));
    //Grand Total Amount Excluded VAT
    let GtotalAmountExcluded = arrGtotalAmountOfInvoice.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
    //Grand Total VAT
    let GroupByinvoice = [];
    let arrinvoiceVat = [];
    let arrinvoiceWHT = [];
    _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
      //GroupByinvoice[value.sInvoiceNo] = GroupByinvoice[value.sInvoiceNo] || [];
      let obj = {
        invoice: value.sInvoiceNo,
        InvoiceDate: value.dInvoiceDate
      }
      let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
      if (ckhave.length == 0) {
        GroupByinvoice.push(obj)
      }
    });
    GroupByinvoice.forEach(function (value, i) {
      //arrinvoiceVat.push(_thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N')[0].nVAT)
      let Get_InvoiceVat = _thisOther.ArrInvoiceOther.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
      if (Get_InvoiceVat.length > 0) {
        arrinvoiceVat.push(_thisOther.Check2Digit(Get_InvoiceVat[0].nVAT));
        arrinvoiceWHT.push(_thisOther.Check2Digit(Get_InvoiceVat[0].nWHTVal) + _thisOther.Check2Digit(Get_InvoiceVat[0].nWHTVal2));
      }
    })
    let GtotalVAT = _ParseFloatToZero(arrinvoiceVat.reduce((acc, cur) => (acc + cur), 0));
    let GtotalWHT = _ParseFloatToZero(arrinvoiceWHT.reduce((acc, cur) => (acc + cur), 0));
    ////Grand Total Withholding Tax
    //let GtotalAmountExcluded = arrGtotalAmouGtotalAmountExcluded.reduce((acc, cur) => acc + Number(cur), 0).toFixed(2)
    //Grand Total Amount
    // let arrGtotalWithholdingTax = _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _ParseFloatToZero(m.nWHTVal));
    // let arrGtotalWithholdingTax2 = _thisOther.ArrInvoiceOther.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _ParseFloatToZero(m.nWHTVal2));
    // let GtotalWithholdingTax = _ParseFloatToZero(arrGtotalWithholdingTax.reduce((acc, cur) => (acc + cur), 0))
    // let GtotalWithholdingTax2 = _ParseFloatToZero(arrGtotalWithholdingTax2.reduce((acc, cur) => (acc + cur), 0))

    let GtotalAmountOfInvoice = _ParseFloatToZero(((_ParseFloatToZero(GtotalVAT) + _ParseFloatToZero(GtotalAmountExcluded)) - _ParseFloatToZero(GtotalWHT)).toFixed(2))
    this.paytoOtherForm.patchValue({
      GtotalAmountExcluded: (GtotalAmountExcluded),
      GtotalVAT: (GtotalVAT),
      GtotalWithholdingTax: (GtotalWHT == "NaN" ? 0 : GtotalWHT),
      GtotalAmountOfInvoice: (GtotalAmountOfInvoice),
    })

  }
  numberOnly(event): boolean {
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }
  convertTodate(dDate) {
    let chunks = dDate.split('/');
    return new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
  }
  _ConvertToDecimal(sVal) {
    if(!sVal || sVal === 'NaN') sVal = '0';
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }
  //NoResult
  TypeNoResults(event: boolean): void {
    this.TypeNoResult = event;
    if (event) {
      this.VendorCodemaxLength = 11;
    } else {
      this.VendorCodemaxLength = 50;
    }
  }
  TypeOnBlur(event) {
    var vendorcode = this.paytoOtherForm.get('nVendorCode').value;
    var ischeck = this.ArrVendor.filter(f => f.VENDOR_CODE == vendorcode || f.Vendor == vendorcode)[0];
    if (this.TypeNoResult == true && this.paytoOtherForm.get("ntype").value == "10") {
      this.paytoOtherForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    } else if (this.TypeNoResult == true && this.paytoOtherForm.get("ntype").value != "10") {
      this.onTypeSelect(null, true);
    }
    if (this.TypeNoResult == false && !isNullOrUndefined(ischeck)) {
      this.onVendorSelect(event);
    } else if (this.TypeNoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoOtherForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    }
    if (this.IsVendorOneTime == true) {
      if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoiceOther.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.value != null && !_IsNullOrEmpty(event.value)) {
            invoice.sVendorCode = event.value == null ? "" : event.value;
          } else {
            invoice.sVendorCode = "";
          }
        })
      }
    }
  }
  CopyNoResults(event: boolean): void {
    this.CopyNoResult = event;
  }
  CopyOnBlur(item) {
    let sCopyRequest = this.paytoOtherForm.get('sCopyRequest').value;
    let ischeck = this.DataRequest.filter(user => user.sRequestCode == sCopyRequest)[0];
    if (this.DataRequest) {
      if (sCopyRequest == "") {
        /*  this.ArrInvoiceOther = [];
          this.ClearInvoice();
          this.Checkinvoice(); */

      } else if (sCopyRequest != "" && this.CopyNoResult == false && !isNullOrUndefined(ischeck)) {
        this.onCopyRequestCodeSelect(item)
      }
      if (this.CopyNoResult == true) {
        this.paytoOtherForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null
        });
        /*   this.ArrInvoiceOther = [];
           this.ClearInvoice();
           this.Checkinvoice();*/
      } else if (this.CopyNoResult == false && isNullOrUndefined(ischeck)) {
        this.paytoOtherForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null
        });
      }
    }
  }
  //Country NoResult ------------------------------------------

  CountryNoResult(event: boolean): void {
    this.isCountryNoResult = event;
  }
  CountryOnBlur() {
    if (this.isCountryNoResult == true) {
      this.paytoOtherForm.patchValue({ txtCountryID: null });
    }
  }
  NoResultsAmphor(event: boolean): void {
    this.sAmphorNoResult = event;
  }
  NoResultsTumbon(event: boolean): void {
    this.sTumbonNoResult = event;
  }
  NoResultsSubDistrict(event: boolean): void {
    this.sSubDistrictNoResult = event;
  }

  //-----------------------------------------------------------
  GlNoResults(event: boolean, index): void {

    this.GlNoResult[index] = event;
  }
  GlOnBlur(event, index) {
    if (this.GlNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sGL: null })
    }
  }
  CostCenterNoResults(event: boolean, index): void {
    this.CostCenterNoResult[index] = event;
  }
  CostCenterOnBlur(event, index) {
    if (this.CostCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sCostCenter: null })
    }
  }
  IONoResults(event: boolean, index): void {
    this.IONoResult[index] = event;
  }
  IOOnBlur(event, index) {
    if (this.IONoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sIO: null })
    }
  }
  BankNoResults(event: boolean): void {
    this.BankNoResult = event;
  }

  BankNoResults2(event: boolean): void {
    this.BankNoResult2 = event;
  }
  BankOnBlur(item) {
    let bank = this.paytoOtherForm.get('ddBankKey').value;
    let ischeck = this.DataBankBranch.filter(f => f.Show == bank);
    if (ischeck.length == 0) {
      ischeck = this.DataBankBranch.filter(f => f.NAME_OF_BANK == bank);
      if (ischeck.length == 0) {
        ischeck = this.DataBankBranch.filter(f => f.BANK_KEY == bank);
      }
    }
    if (this.BankNoResult == true) {
      this.paytoOtherForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytoOtherForm.controls['ddBankKey2'].disable();
    } else if (this.BankNoResult == false && ischeck.length > 0) {
      this.onBankBranchSelect(item);
    } else if (this.BankNoResult == false && ischeck.length == 0) {
      this.paytoOtherForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytoOtherForm.controls['ddBankKey2'].disable();
    }
  }
  BankOnBlur2(item) {
    let bank = this.paytoOtherForm.get('ddBankKey2').value;
    let ischeck = this.DataBankBranch2.filter(f => f.BANK_ACCOUNT == bank);
    if (this.BankNoResult2 == true) {
      this.paytoOtherForm.patchValue({ ddBankKey2: null });
    } else if (this.BankNoResult2 == false && ischeck.length > 0) {
      this.onBankBranchSelect2(item);
    } else if (this.BankNoResult2 == false && ischeck.length == 0) {
      this.paytoOtherForm.patchValue({ ddBankKey2: null });
    }
  }
  Approver2NoResults(event: boolean): void {
    this.Approve2NoResult = event;
  }
  Approver1NoResults(event: boolean): void {
    this.Approve1NoResult = event;
  }
  //
  Checkinvoice() {
    let _thisOther = this;
    let lstData = this.ArrInvoiceOther.filter(f => f.cActive != 'N')[0];
    this.ArrInvoicelength = this.ArrInvoiceOther.filter(f => f.cActive != 'N').length;
    let onetime = ["sVendorName", "sTAXID", "sAddress", "sBranch", "cbOffice", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
    // "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail", "sAddressOneTime"
    if (this.ArrInvoiceOther.filter(f => f.cActive != 'N').length >= 1) {
        onetime.forEach(function (value) {
          //  _thisOther.paytoOtherForm.controls[value].disable();
          _thisOther.paytoOtherForm.controls[value].markAsUntouched({ onlySelf: true });
        })
      //  this.paytoOtherForm.controls['dDueDate'].disable();
      this.paytoOtherForm.controls['ntype'].disable();
      //  this.paytoOtherForm.controls['nVendorCode'].disable();
      this.paytoOtherForm.controls['ddCurrency'].disable();
      this.paytoOtherForm.controls['nVendorCode'].markAsUntouched({ onlySelf: true });
      //if
    } else {
      onetime.forEach(function (value) {
        _thisOther.paytoOtherForm.controls[value].enable();
      });
      this.paytoOtherForm.controls['dDueDate'].enable();
      //   this.paytoOtherForm.controls['ddCurrency'].enable();
      //  this.paytoOtherForm.controls['dDueDate'].enable();
      this.paytoOtherForm.controls['ddCurrency'].enable();
      this.paytoOtherForm.controls['ntype'].enable();
      //this.paytoOtherForm.controls['nVendorCode'].enable();

      this.ClearInvoice();
    }
  }
  clearSubinvoice() {
    let _thisOther = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sInvoiceNo", "dInvoiceDate", "ddVatType", "nTotalAmountVat"];
    for (let i = 0; i < FieldValid.length; i++) {
      _thisOther.paytoOtherForm.get(FieldValid[i]).markAsUntouched();
    }
    this.paytoOtherForm.patchValue({
      sInvoiceNo: null,
      dInvoiceDate: new Date(),
      nTotalAmount: null,
      // ddCurrency: "THB",
      nVat: null,
      ddVatType: "-1",
      nVatAmount: null,
      nTotalAmountInvoice: null,
      nTotalAmountVat: null,
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTRate: null,
      nWHTRate2: null,
      nWHTOther: null,
      nWHTOther2: null,
      nWHTVal: null,
      _nWHTVal: null,
      nWHTVal2: null,
      _nWHTVal2: null,
      nWHTBase: null,
      nWHTBase2: null,
    })
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytoOtherForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl(''),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();
    this.onWithholdingTaxSelect(1, false);
    this.onWithholdingTaxSelect(2, false);
  }
  calVat() {
    let Total: number = _ParseFloatToZero(this.paytoOtherForm.value.nTotalAmountVat)
    let Vat: number = this.paytoOtherForm.value.nVat == null ? 0 : this.paytoOtherForm.value.nVat
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    this.paytoOtherForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })
  }
  checkUseIo() {
    let _thisOther = this;
    if (this.isUseIo) {
      _thisOther.IsNotFill_IO = false;
      _thisOther.ArrGL.controls.forEach(function (row) {
        row.get('sIO').enable();

      })
    } else {
      _thisOther.IsNotFill_IO = true;
      _thisOther.ArrGL.controls.forEach(function (row) {
        row.get('sIO').disable();
      })
    }
  }
  checkUseGL() {
    let _thisOther = this;
    if (this.isUseGL) {
      _thisOther.IsNotFill_GL = false;
      _thisOther.ArrGL.controls.forEach(function (row) {
        row.get('sGL').enable();


      })
    } else {
      _thisOther.IsNotFill_GL = true;
      _thisOther.ArrGL.controls.forEach(function (row) {
        row.get('sGL').disable();
      })
    }
  }
  Check2Digit(sValue) {
    let Result: number = 0;
    if (sValue) {
      let sValueNoComma = (sValue + "").replace(/,/g, "")
      let sValueNoComma2 = Math.round(parseFloat(sValueNoComma) * 100) / 100
      Result = Number(sValueNoComma2.toFixed(2));
    }
    return Result;
  }
}
function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}
function _ParseFloatToZero(sVal) {
  let Result: any = 0;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
function _ParseFloatToNull(sVal) {
  let Result: any = null;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
